/* ═══════════════════════════════════════════════════════════════
   NENSONS EXCHANGE BOARD — EXPORT MODULE v15 (ELEMENT MOTION)
   Based on v14 + the MP4 blocks. What changed:
     1. BLOCK D: the video no longer slides finished pictures around.
        Each sheet's title, info rows, product name, medal and price
        box arrive on their own beat.
     2. VIDEO.slideEase corrected — v14's value was an ease-IN, the
        opposite of what its own comment described.
     3. createIndividualCard takes an options object: it can skip the
        background, and it reports the geometry it already computes.
     4. drawCardsGrid can collect the rect of each grid cell.

   The ZIP output is byte-for-byte what v14 produced. Nothing in the
   drawing code moved; the motion layer only re-composites it.

   FILE ORDER: individual sheets keep v12's numbering — 01, 02, 03…
   follow the rail left to right. The medal badge drawn on each sheet
   is the real rank, so 01 carries the highest badge number.
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  if (window.__exchangeRailsReady) return;
  window.__exchangeRailsReady = true;

  /* ═══════════════════════════════════════════════════════════════
     PART 1: DRAG TO SCROLL (Original - UNCHANGED)
     ═══════════════════════════════════════════════════════════════ */

  var SCROLLERS = '.dc-page .rail, .dc-page .board-scroll, .dc-page .tabs';
  var NO_DRAG = 'input, select, textarea, a, .rail-nav, .export-btn, .export-option';

  var LERP = 0.16;
  var FRICTION = 0.972;
  var MIN_VEL = 0.04;
  var RUBBER = 0.32;
  var SPRING = 0.16;
  var THRESHOLD = 4;

  var el = null;
  var pos = 0, target = 0, vel = 0, startX = 0, startLeft = 0;
  var pressed = false, pointerId = null;
  var dragging = false, suppressClick = false, raf = null;

  function maxScroll() { return el ? el.scrollWidth - el.clientWidth : 0; }

  function claim(node) {
    if (node.dataset.railClaimed) return;
    node.dataset.railClaimed = '1';
    node.style.scrollSnapType = 'none';
    node.style.scrollBehavior = 'auto';
  }

  function stopMotion() {
    if (raf) { cancelAnimationFrame(raf); raf = null; }
    if (el) el.classList.remove('is-dragging');
    el = null;
    dragging = false;
    vel = 0;
  }

  function endPress() {
    pressed = false;
    pointerId = null;
    dragging = false;
    if (el) el.classList.remove('is-dragging');
  }

  function tick() {
    if (!el) { raf = null; return; }
    raf = requestAnimationFrame(tick);
    var max = maxScroll();

    if (dragging && pressed) {
      var t = target;
      if (t < 0) t = t * RUBBER;
      else if (t > max) t = max + (t - max) * RUBBER;
      var prev = pos;
      pos += (t - pos) * LERP;
      vel = vel * 0.62 + (pos - prev) * 0.38;
    } else if (pos < 0 || pos > max) {
      var bound = pos < 0 ? 0 : max;
      pos += (bound - pos) * SPRING;
      vel = 0;
      if (Math.abs(bound - pos) < 0.3) { el.scrollLeft = bound; stopMotion(); return; }
    } else {
      pos += vel;
      vel *= FRICTION;
      if (pos < 0) { pos = 0; vel *= -0.28; }
      else if (pos > max) { pos = max; vel *= -0.28; }
      if (Math.abs(vel) < MIN_VEL) { el.scrollLeft = pos; stopMotion(); return; }
    }

    el.scrollLeft = pos;
  }

  function run() { if (!raf) raf = requestAnimationFrame(tick); }

  // Lets the arrow buttons take over mid-flick. Without this the loop above
  // keeps writing scrollLeft every frame and undoes whatever they set.
  window.__nenRail = {
    stop: function (node) {
      if (!el) return false;
      if (node && el !== node) return false;
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      el.classList.remove('is-dragging');
      el = null;
      dragging = false;
      pressed = false;
      pointerId = null;
      vel = 0;
      return true;
    },
    claimed: function (node) { return !!(node && node.dataset.railClaimed); }
  };

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
    if (e.button !== 0 || !e.target || !e.target.closest) return;

    var t = e.target.closest(SCROLLERS);
    if (!t) return;
    if (t.scrollWidth <= t.clientWidth + 2) return;
    if (e.target.closest(NO_DRAG)) return;

    claim(t);

    if (raf) { cancelAnimationFrame(raf); raf = null; }
    if (el && el !== t) el.classList.remove('is-dragging');

    el = t;
    pos = target = startLeft = t.scrollLeft;
    startX = e.clientX;
    vel = 0;
    dragging = false;
    pressed = true;
    pointerId = e.pointerId;
  });

  document.addEventListener('pointermove', function (e) {
    if (!pressed || !el) return;
    if (pointerId != null && e.pointerId !== pointerId) return;
    if (!(e.buttons & 1)) { endPress(); run(); return; }

    var dx = e.clientX - startX;

    if (!dragging) {
      if (Math.abs(dx) < THRESHOLD) return;
      dragging = true;
      startLeft = pos;
      startX = e.clientX;
      dx = 0;
      el.classList.add('is-dragging');
      run();
    }

    e.preventDefault();
    target = startLeft - dx;
  }, { passive: false });

  document.addEventListener('pointerup', function (e) {
    if (!pressed) return;
    if (pointerId != null && e.pointerId !== pointerId) return;

    var wasDragging = dragging;
    endPress();

    if (!wasDragging) { stopMotion(); return; }

    suppressClick = true;
    setTimeout(function () { suppressClick = false; }, 80);

    run();
  });

  document.addEventListener('pointercancel', function () { endPress(); stopMotion(); });
  window.addEventListener('blur', function () { endPress(); });

  document.addEventListener('click', function (e) {
    if (!suppressClick) return;
    // The rail arrows are a deliberate press, never the tail of a drag —
    // swallowing them is what made a click just after a flick do nothing.
    if (e.target && e.target.closest && e.target.closest('.rail-nav')) {
      suppressClick = false;
      return;
    }
    suppressClick = false;
    e.stopPropagation();
    e.preventDefault();
  }, true);

  document.addEventListener('dragstart', function (e) {
    if (dragging || (e.target && e.target.closest && e.target.closest(SCROLLERS))) e.preventDefault();
  });

  /* ═══════════════════════════════════════════════════════════════
     PART 2: ENHANCED EXPORT WITH BACKGROUNDS & REAL PRICES
     ═══════════════════════════════════════════════════════════════ */

  if (window.__exchangeExportReady) return;
  window.__exchangeExportReady = true;

  var MAX_CARDS = 10;   // ceiling, never a target

  // The gold frame on a single sheet is drawn around the artwork itself
  // rather than around the reserved box. Set to false to go back to v13's
  // fixed-width frame (which shows background bars beside the art).
  var FRAME_HUGS_ART = true;

  /* ═══════════════════════════════════════════════════════════════
     ★★★ BACKGROUNDS — ONE SET PER FORMAT ★★★
     ═══════════════════════════════════════════════════════════════ */

  var BACKGROUNDS_SQUARE = [
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_1.png?v=1786505771',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_2.png?v=1786505771',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_3.png?v=1786505771',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_4.png?v=1786505771',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_5_LOGO.png?v=1787036527',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_6_LOGO.png?v=1787036527',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_7_LOGO.png?v=1787036527',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_8_LOGO.png?v=1787036527',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_9_LOGO.png?v=1787036527',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_10_LOGO.png?v=1787036527'
  ];

  var BACKGROUNDS_VERTICAL = [
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_1_VERTICAL.png?v=1787511402',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_2_VERTICAL.png?v=1787511402',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_3_VERTICAL.png?v=1787511402',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_4_VERTICAL.png?v=1787511402',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_5_LOGO_VERTICAL.png?v=1787511402',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_6_LOGO_VERTICAL.png?v=1787511402',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_7_LOGO_VERTICAL.png?v=1787511402',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_8_LOGO_VERTICAL.png?v=1787511402',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_9_LOGO_VERTICAL.png?v=1787511402',
    'https://cdn.shopify.com/s/files/1/0731/4128/9172/files/BACKGROUND_TOP_10_10_LOGO_VERTICAL.png?v=1787511402'
  ];

  /* ═══════════════════════════════════════════════════════════════
     ★★★ FORMATS ★★★
     Every number the canvas code used to hard-code lives here.
     ═══════════════════════════════════════════════════════════════ */

  var FORMATS = {
    instagram: {
      key: 'instagram',
      label: 'Instagram',
      btn: 'Instagram 1:1',
      tag: 'IG',
      W: 1080,
      H: 1080,
      backgrounds: BACKGROUNDS_SQUARE,
      logoSafeX: 170,

      // ── collage: gold title row ──
      titleY: 78,
      titleMax: 80,
      titleMin: 34,
      titleStep: 3,
      setGap: 22,
      titleBlockBottom: 214,

      // ── collage: cyan info rows ──
      infoBandTop: 18,
      infoRowGap: 16,
      infoMaxOne: 62,
      infoMaxMulti: 46,
      infoMin: 18,

      // ── collage: grid ──
      gridTop: 0.22,
      gridBottomPad: 80,
      gridSidePad: 20,
      maxImgW: 360,
      hGap: 8,
      rowGap: 12,
      maxCols: 5,

      // ── collage: footer ──
      footerH: 48,
      footerFont: 24,
      footerBaseline: 15,

      // ── single sheet ──
      s_titleY: 58,
      s_titleMax: 52,
      s_titleMin: 26,
      s_titleStep: 2,
      s_setGap: 16,
      s_infoMax: 34,
      s_infoMin: 14,
      s_infoOneRowMin: 24,
      s_infoOffset: 30,
      s_infoGap: 10,
      s_nameOffset: 24,
      s_nameLineGap: 6,
      s_badgeR: 40,
      s_badgeGap: 50,
      s_badgeFont: 40,
      s_artW: 560,
      s_artMinY: 300,
      s_artMinH: 500,
      s_artBottom: 980,
      s_priceGap: 10,
      s_priceBoxH: 50,
      s_priceBoxMaxW: 900,
      s_priceSize: 36,
      s_priceMin: 18,
      s_pillH: 40,
      s_groupGap: 22,
      s_footerH: 34,
      s_footerFont: 20,
      s_footerBaseline: 11
    },

    youtube: {
      key: 'youtube',
      label: 'YouTube',
      btn: 'YouTube 9:16',
      tag: 'YT',
      W: 1080,
      H: 1920,
      backgrounds: BACKGROUNDS_VERTICAL,
      logoSafeX: 170,

      // ── collage: gold title row ──
      titleY: 150,
      titleMax: 104,
      titleMin: 40,
      titleStep: 4,
      setGap: 26,
      titleBlockBottom: 400,

      // ── collage: cyan info rows ──
      infoBandTop: 26,
      infoRowGap: 22,
      infoMaxOne: 78,
      infoMaxMulti: 58,
      infoMin: 22,

      // ── collage: grid ──
      gridTop: 0.22,          // 1920 * 0.22 = 422
      gridBottomPad: 110,
      gridSidePad: 20,
      maxImgW: 460,
      hGap: 12,
      rowGap: 18,
      maxCols: 4,

      // ── collage: footer ──
      footerH: 68,
      footerFont: 30,
      footerBaseline: 22,

      // ── single sheet ──
      s_titleY: 108,
      s_titleMax: 76,
      s_titleMin: 34,
      s_titleStep: 3,
      s_setGap: 22,
      s_infoMax: 50,
      s_infoMin: 18,
      s_infoOneRowMin: 34,
      s_infoOffset: 44,
      s_infoGap: 16,
      s_nameOffset: 36,
      s_nameLineGap: 10,
      s_badgeR: 58,
      s_badgeGap: 72,
      s_badgeFont: 58,
      s_artW: 780,
      s_artMinY: 560,
      s_artMinH: 800,
      s_artBottom: 1720,
      s_priceGap: 18,
      s_priceBoxH: 76,
      s_priceBoxMaxW: 980,
      s_priceSize: 54,
      s_priceMin: 26,
      s_pillH: 58,
      s_groupGap: 30,
      s_footerH: 52,
      s_footerFont: 28,
      s_footerBaseline: 17
    }
  };

  // Sticks for the session. Changed from the export dialog.
  var exportFormat = 'instagram';

  function fmt() { return FORMATS[exportFormat] || FORMATS.instagram; }

  // The rate used for the USD line on exports. Seeded from the active
  // snapshot when it carries one, then overridden by whatever the user
  // types in the export dialog. Null means MXN only — better than a
  // wrong number. NOT a live lookup: dividing today's rate into a price
  // converted last week gives a USD figure that corresponds to nothing.
  var exportRate = null;

  // Set from the export dialog, cleared each time it opens. Overrides the
  // auto-generated "Cartas Zoro, Luffy…" line, which gets unreadable once
  // you're searching four or five names.
  var titleOverride = '';

  function defaultRate() {
    try {
      var S = window.__EB_STATE;
      if (!S || !S.snapshots || !S.snapshots.length) return null;
      // walk back to the newest snapshot that actually has one
      for (var i = S.activeIdx; i >= 0; i--) {
        var s = S.snapshots[i];
        var n = parseFloat(s && s.rate && s.rate.usd_mxn);
        if (!isNaN(n) && n > 0) return n;
      }
    } catch (e) { /* fall through */ }
    return null;
  }

  function money(n, suffix) {
    return '$' + n.toLocaleString('en-US', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + (suffix ? ' ' + suffix : '');
  }

  // "$155,732.33 MXN · $8,214.50 USD", or just MXN when there is no rate
  function priceLabel(mxn) {
    if (!exportRate) return money(mxn);
    return money(mxn, 'MXN') + ' · ' + money(mxn / exportRate, 'USD');
  }

  var JSZip = null;
  var zipLoaded = false;

  function loadJSZip() {
    return new Promise(function(resolve) {
      if (zipLoaded) {
        resolve(JSZip);
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
      script.onload = function() {
        JSZip = window.JSZip;
        zipLoaded = true;
        resolve(JSZip);
      };
      script.onerror = function() {
        console.error('Failed to load JSZip');
        resolve(null);
      };
      document.head.appendChild(script);
    });
  }

  var selectedBackground = null;

  function getRandomBackground(F) {
    var list = (F && F.backgrounds) || BACKGROUNDS_SQUARE;
    return list[Math.floor(Math.random() * list.length)];
  }

  /* Fills w x h without distorting the source — crops the overflow instead
     of stretching, which is what a fixed drawImage(0,0,W,H) was doing. */
  function drawCover(ctx, img, w, h) {
    if (!img) return;
    if (!img.width || !img.height) { ctx.drawImage(img, 0, 0, w, h); return; }
    var s = Math.max(w / img.width, h / img.height);
    var dw = img.width * s;
    var dh = img.height * s;
    ctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
  }

  function showToast(message, type) {
    type = type || 'success';
    var toast = document.createElement('div');
    toast.className = 'export-toast ' + type;
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(function () {
      toast.style.animation = 'slideOutRight 0.26s cubic-bezier(0.22, 1, 0.36, 1) forwards';
      setTimeout(function () { toast.remove(); }, 260);
    }, 2800);
  }

  /* ═══════════════════════════════════════════════════════════════
     WHICH CONTAINER DOES THIS BUTTON READ?
     ═══════════════════════════════════════════════════════════════ */

  var SECTION_SCOPES = {
    'TOP 10': function () {
      return document.getElementById('top10');
    },
    'TOP MOVERS': function () {
      return document.getElementById('movers');
    },
    'MARKET BOARD': function () {
      var host = document.getElementById('viewHost');
      if (!host) return null;
      // whichever layout the active tab is showing
      return host.querySelector('.rail') ||
             host.querySelector('.cgrid') ||
             host.querySelector('tbody') ||
             host.querySelector('.mv-list') ||
             host;
    }
  };

  function isVisible(node) {
    var style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (parseFloat(style.opacity) === 0) return false;
    var rect = node.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2;
  }

  /* ═══════════════════════════════════════════════════════════════
     REAL CHANGE % FROM THE PAGE
     ═══════════════════════════════════════════════════════════════ */

  function readChange(el) {
    var node = el.querySelector('.dl') || el.querySelector('.c') || el.querySelector('.ch-cell');
    if (!node) return null;
    var text = node.textContent.trim();
    var match = text.match(/(-?\d+(?:\.\d+)?)\s*%/);
    if (!match) return null;
    var value = parseFloat(match[1]);
    if (isNaN(value)) return null;
    if (text.indexOf('▼') >= 0 && value > 0) value = -value;   // arrow carries the sign
    return value;
  }

  function readRankBadge(el) {
    var badge = el.querySelector('.rk-badge') || el.querySelector('.rk');
    if (!badge) return null;
    var match = badge.textContent.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : null;
  }

  function getCardsFromSnapshot(count, scope) {
    // Snapshot data only if the page actually exposes it.
    if (window.__EB_STATE && window.__EB_STATE.snapshots) {
      var snapshots = window.__EB_STATE.snapshots;
      var activeIdx = window.__EB_STATE.activeIdx;

      if (snapshots[activeIdx]) {
        var snapshot = snapshots[activeIdx];
        var topCards = snapshot.cards
          .slice()
          .sort(function(a, b) { return (b.price || 0) - (a.price || 0); })
          .slice(0, count || MAX_CARDS)
          .map(function(c, idx) {
            return {
              index: idx,
              name: c.name || c.ticker || 'Card ' + (idx + 1),
              price: parseFloat(c.price) || 0,
              image: c.image || '',
              ticker: c.ticker || '',
              set: c.set || '',
              rarity: c.rarity || '',
              color: c.color || '',
              qty: c.qty || 0,
              price_source: c.price_source || 'unknown',
              rank: null
            };
          });

        console.log('✅ Loaded ' + topCards.length + ' cards from snapshot');
        return topCards;
      }
    }

    return getCardsFromBoard(scope);
  }

  function getCardsFromBoard(scope) {
    var cards = [];
    var seen = {};
    var root = scope || document;
    var cardElements = root.querySelectorAll('[data-i]');

    Array.prototype.forEach.call(cardElements, function(el, idx) {
      try {
        if (el.closest('.tape-track')) return;          // the ticker tape repeats itself
        if (!isVisible(el)) return;                     // nothing hidden by a filter

        var cardIndex = el.getAttribute('data-i');
        if (cardIndex == null || seen[cardIndex]) return;

        // NAME: .nm on a tile, .n on a mover row, .nm-cell in the table
        var nmEl = el.querySelector('.nm') || el.querySelector('.n') || el.querySelector('.nm-cell');
        var cardName = nmEl ? nmEl.textContent.trim() : 'Card ' + (idx + 1);

        // PRICE: .px on a tile, .p on a mover row, .px-cell in the table
        var pxEl = el.querySelector('.px') || el.querySelector('.p') || el.querySelector('.px-cell');
        var priceText = pxEl ? pxEl.textContent.trim() : '';

        var cardPrice = 0;
        if (priceText && priceText.indexOf('—') < 0) {
          var cleanPrice = priceText
            .replace(/[$\s]/g, '')      // Remove $ and spaces
            .replace(/,/g, '');          // Remove commas
          cardPrice = parseFloat(cleanPrice) || 0;
        }

        var cardImage = null;
        cardImage = el.getAttribute('data-image') || el.getAttribute('data-cardsrc');

        if (!cardImage) {
          var imgTag = el.querySelector('img');
          if (imgTag && imgTag.src) {
            cardImage = imgTag.src;
          }
        }

        if (!cardImage) {
          var allImgs = el.querySelectorAll('img');
          if (allImgs.length > 0) {
            for (var i = 0; i < allImgs.length; i++) {
              if (allImgs[i].src) {
                cardImage = allImgs[i].src;
                break;
              }
            }
          }
        }

        if (cardImage && cardImage.trim()) {
          cardImage = cardImage.split('?')[0];
          seen[cardIndex] = true;

          cards.push({
            index: cardIndex,
            name: String(cardName).trim().substring(0, 100),
            price: cardPrice,
            image: cardImage,
            ticker: el.getAttribute('data-ticker') || String(cardName).trim().substring(0, 20),
            rank: readRankBadge(el),
            change: readChange(el)
          });
        }

      } catch (error) {
        console.error('Error processing card:', error);
      }
    });

    return cards.slice(0, MAX_CARDS);   // ceiling only — no padding to 10
  }

  /* Assigns the final rank to every card. */
  function applyRanks(cards) {
    var total = cards.length;
    var allBadged = cards.every(function (c) { return typeof c.rank === 'number' && c.rank > 0; });

    cards.forEach(function (card, idx) {
      // The rail paints #N first and #1 last (podium order). With ten cards
      // total - idx reproduces v12's 11 - rank exactly; with three it gives
      // 3, 2, 1 — which is what the badges show.
      if (!allBadged) card.rank = total - idx;
    });

    return cards;
  }

  function loadImage(url, timeout) {
    timeout = timeout || 5000;
    return new Promise(function(resolve) {
      if (!url) {
        resolve(null);
        return;
      }

      var img = new Image();
      img.crossOrigin = 'anonymous';

      var timer = setTimeout(function() {
        console.warn('[export] image timed out:', url);
        resolve(null);
      }, timeout);

      img.onload = function() {
        clearTimeout(timer);
        resolve(img);
      };

      img.onerror = function() {
        clearTimeout(timer);
        console.warn('[export] image failed (CORS or 404):', url);
        resolve(null);
      };

      img.src = url;
    });
  }

  function getSpanishDateString() {
    var monthsES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    var date = new Date();
    var day = date.getDate();
    var month = monthsES[date.getMonth()];
    var year = date.getFullYear();
    return day + ' de ' + month + ' de ' + year;
  }

  function drawElegant3DText(ctx, text, x, y, fontSize, textAlign) {
    textAlign = textAlign || 'center';

    ctx.font = 'bold ' + fontSize + 'px "Arial Black", Arial, sans-serif';
    ctx.textAlign = textAlign;
    ctx.textBaseline = 'alphabetic';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    // Layer 1: Subtle black shadow (depth)
    ctx.lineWidth = 5;
    ctx.strokeStyle = '#000000';
    ctx.globalAlpha = 0.8;
    ctx.strokeText(text, x + 2, y + 3);

    // Layer 2: Very thin dark outline for definition
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#1A1A2E';
    ctx.globalAlpha = 1;
    ctx.strokeText(text, x, y);

    // Layer 3: Gradient fill (white to light cyan)
    var textWidth = ctx.measureText(text).width;
    var gradX0, gradX1;
    if (textAlign === 'left') { gradX0 = x; gradX1 = x + textWidth; }
    else if (textAlign === 'right') { gradX0 = x - textWidth; gradX1 = x; }
    else { gradX0 = x - textWidth / 2; gradX1 = x + textWidth / 2; }

    var gradient = ctx.createLinearGradient(gradX0, y - 30, gradX1, y + 30);
    gradient.addColorStop(0, '#FFFFFF');
    gradient.addColorStop(0.5, '#E0FFFF');
    gradient.addColorStop(1, '#00D9FF');
    ctx.fillStyle = gradient;
    ctx.fillText(text, x, y);

    // Layer 4: Thin bright cyan rim highlight
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(0, 217, 255, 0.6)';
    ctx.globalAlpha = 0.7;
    ctx.strokeText(text, x - 0.5, y - 0.5);

    ctx.globalAlpha = 1;
  }

  /* The size at which `text` best fills `maxWidth`, clamped to the range. */
  function fitTextSize(ctx, text, maxSize, maxWidth, minSize) {
    minSize = minSize || Math.round(maxSize * 0.55);

    var REF = 100;
    ctx.font = 'bold ' + REF + 'px "Arial Black", Arial, sans-serif';
    var widthPerPx = ctx.measureText(text).width / REF;

    var size = widthPerPx > 0 ? (maxWidth / widthPerPx) : maxSize;
    return Math.max(minSize, Math.min(maxSize, Math.floor(size)));
  }

  function drawFittedElegantText(ctx, text, x, y, maxSize, maxWidth, minSize) {
    var size = fitTextSize(ctx, text, maxSize, maxWidth, minSize);
    drawElegant3DText(ctx, text, x, y, size, 'center');
    return size;
  }

  /* ═══════════════════════════════════════════════════════════════
     CHANGE PILL — the ▲ +18.4% / ▼ -13.1% badge
     ═══════════════════════════════════════════════════════════════ */

  function roundRectPath(ctx, x, y, w, h, r) {
    r = Math.min(r, h / 2, w / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
  }

  function changePillWidth(ctx, value, height) {
    var text = (value > 0 ? '▲ +' : '▼ ') + value.toFixed(1) + '%';
    ctx.font = 'bold ' + Math.round(height * 0.54) + 'px "Arial Black", Arial, sans-serif';
    return ctx.measureText(text).width + height * 1.1;
  }

  /* Centred on (cx, cy). Returns the width it used. */
  function drawChangePill(ctx, cx, cy, value, height) {
    var up = value > 0;
    var text = (up ? '▲ +' : '▼ ') + value.toFixed(1) + '%';
    var fontSize = Math.round(height * 0.54);

    ctx.font = 'bold ' + fontSize + 'px "Arial Black", Arial, sans-serif';
    var width = ctx.measureText(text).width + height * 1.1;
    var x = cx - width / 2;
    var y = cy - height / 2;

    // drop shadow
    ctx.fillStyle = 'rgba(0, 0, 0, 0.45)';
    roundRectPath(ctx, x + 2, y + 3, width, height, height / 2);
    ctx.fill();

    // body
    var grad = ctx.createLinearGradient(x, y, x, y + height);
    if (up) {
      grad.addColorStop(0, '#2BF0A8');
      grad.addColorStop(1, '#00A870');
    } else {
      grad.addColorStop(0, '#FF7A87');
      grad.addColorStop(1, '#C41E32');
    }
    ctx.fillStyle = grad;
    roundRectPath(ctx, x, y, width, height, height / 2);
    ctx.fill();

    // rim
    ctx.strokeStyle = up ? 'rgba(155, 255, 217, 0.95)' : 'rgba(255, 184, 190, 0.95)';
    ctx.lineWidth = Math.max(1.5, height * 0.07);
    roundRectPath(ctx, x, y, width, height, height / 2);
    ctx.stroke();

    // inner highlight along the top
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.35)';
    ctx.lineWidth = Math.max(1, height * 0.05);
    roundRectPath(ctx, x + height * 0.12, y + height * 0.12, width - height * 0.24, height * 0.5, height * 0.25);
    ctx.stroke();

    // label
    ctx.fillStyle = '#FFFFFF';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.shadowColor = 'rgba(0, 0, 0, 0.75)';
    ctx.shadowBlur = Math.max(2, height * 0.18);
    ctx.shadowOffsetY = Math.max(1, height * 0.06);
    ctx.fillText(text, cx, cy + height * 0.02);
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetY = 0;

    return width;
  }

  /* ═══════════════════════════════════════════════════════════════
     COLOUR / RARITY CHIPS
     ═══════════════════════════════════════════════════════════════ */

  var COLOR_CHIP = {
    'rojo':       ['#F04B4B', '#8E1414'],
    'verde':      ['#3FCF6B', '#12662E'],
    'azul':       ['#3E9BF0', '#12457A'],
    'morado':     ['#A85DE8', '#4B1C7A'],
    'negro':      ['#5A6678', '#141A22'],
    'amarillo':   ['#F7CE4A', '#9A7508'],
    'multicolor': ['#F0654B', '#3E9BF0']
  };

  var RARITY_CHIP = {
    LEADER: '#EFC441', SEC: '#C0A0FF', SP: '#FF9ECB', TR: '#F7A072', M: '#FF7B9C',
    AA: '#7AD7F0', SR: '#26E39B', R: '#8AB6FF', UC: '#5FE3B4', C: '#7A98B4',
    P: '#D0A6FF', DON: '#4E677C'
  };

  function hexToRgb(hex) {
    var h = String(hex).replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
  }

  function shade(hex, factor) {
    var c = hexToRgb(hex);
    return 'rgb(' + c.map(function (v) {
      return Math.max(0, Math.min(255, Math.round(v * factor)));
    }).join(',') + ')';
  }

  /* Dark label on light chips, white on dark ones. */
  function labelColorFor(hex) {
    var c = hexToRgb(hex);
    var lum = (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255;
    return lum > 0.62 ? '#12161F' : '#FFFFFF';
  }

  function colorChip(value) {
    var key = String(value).toLowerCase();
    var pair = COLOR_CHIP[key] || ['#7A98B4', '#33475A'];
    return { label: String(value).toUpperCase(), c1: pair[0], c2: pair[1] };
  }

  function rarityChip(value) {
    var key = String(value).toUpperCase();
    var base = RARITY_CHIP[key] || '#7A98B4';
    return { label: key, c1: base, c2: shade(base, 0.48) };
  }

  function chipRowWidth(ctx, chips, h) {
    var gap = h * 0.34;
    var total = 0;
    ctx.font = 'bold ' + Math.round(h * 0.5) + 'px "Arial Black", Arial, sans-serif';
    chips.forEach(function (c, i) {
      total += ctx.measureText(c.label).width + h * 0.95 + (i ? gap : 0);
    });
    return total;
  }

  function drawChip(ctx, x, y, w, h, chip) {
    // shadow
    ctx.fillStyle = 'rgba(0, 0, 0, 0.45)';
    roundRectPath(ctx, x + 2, y + 3, w, h, h / 2);
    ctx.fill();

    // body
    var grad = ctx.createLinearGradient(x, y, x, y + h);
    grad.addColorStop(0, chip.c1);
    grad.addColorStop(1, chip.c2);
    ctx.fillStyle = grad;
    roundRectPath(ctx, x, y, w, h, h / 2);
    ctx.fill();

    // rim
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.55)';
    ctx.lineWidth = Math.max(1.5, h * 0.06);
    roundRectPath(ctx, x, y, w, h, h / 2);
    ctx.stroke();

    // top highlight
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.28)';
    ctx.lineWidth = Math.max(1, h * 0.045);
    roundRectPath(ctx, x + h * 0.12, y + h * 0.11, w - h * 0.24, h * 0.48, h * 0.24);
    ctx.stroke();

    // label
    ctx.font = 'bold ' + Math.round(h * 0.5) + 'px "Arial Black", Arial, sans-serif';
    ctx.fillStyle = labelColorFor(chip.c1);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.shadowColor = 'rgba(0, 0, 0, 0.35)';
    ctx.shadowBlur = Math.max(1, h * 0.1);
    ctx.shadowOffsetY = 1;
    ctx.fillText(chip.label, x + w / 2, y + h / 2 + h * 0.02);
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetY = 0;
  }

  /* Centred row of chips. Shrinks until it fits. Returns the height used. */
  function drawChipRow(ctx, chips, cx, cy, height, maxWidth) {
    var h = height;
    while (h > 16 && chipRowWidth(ctx, chips, h) > maxWidth) h -= 2;

    var gap = h * 0.34;
    var x = cx - chipRowWidth(ctx, chips, h) / 2;

    chips.forEach(function (chip) {
      ctx.font = 'bold ' + Math.round(h * 0.5) + 'px "Arial Black", Arial, sans-serif';
      var w = ctx.measureText(chip.label).width + h * 0.95;
      drawChip(ctx, x, cy - h / 2, w, h, chip);
      x += w + gap;
    });

    return h;
  }

  /* ═══════════════════════════════════════════════════════════════
     MIXED INFO ROWS
     ═══════════════════════════════════════════════════════════════ */

  function segmentsWidth(ctx, segs, size) {
    var gap = size * 0.4;
    var total = 0;
    segs.forEach(function (s, i) {
      if (i) total += gap;
      if (s.type === 'chip') {
        ctx.font = 'bold ' + Math.round(size * 0.5) + 'px "Arial Black", Arial, sans-serif';
        total += ctx.measureText(s.chip.label).width + size * 0.95;
      } else {
        ctx.font = 'bold ' + Math.round(size) + 'px "Arial Black", Arial, sans-serif';
        total += ctx.measureText(s.text).width;
      }
    });
    return total;
  }

  /* One size that lets every row fit. */
  function fitRowsSize(ctx, rows, maxWidth, maxSize, minSize) {
    var REF = 100;
    var size = maxSize;
    rows.forEach(function (segs) {
      if (!segs.length) return;
      var w = segmentsWidth(ctx, segs, REF);
      if (w > 0) size = Math.min(size, maxWidth * REF / w);
    });
    return Math.max(minSize, Math.floor(size));
  }

  /* Draws a row centred on (cx, cy). cy is the row's vertical centre. */
  function drawMixedRow(ctx, segs, cx, cy, size) {
    var gap = size * 0.4;
    var x = cx - segmentsWidth(ctx, segs, size) / 2;

    segs.forEach(function (s) {
      if (s.type === 'chip') {
        ctx.font = 'bold ' + Math.round(size * 0.5) + 'px "Arial Black", Arial, sans-serif';
        var cw = ctx.measureText(s.chip.label).width + size * 0.95;
        drawChip(ctx, x, cy - size / 2, cw, size, s.chip);
        x += cw + gap;
      } else {
        ctx.font = 'bold ' + Math.round(size) + 'px "Arial Black", Arial, sans-serif';
        var tw = ctx.measureText(s.text).width;
        drawElegant3DText(ctx, s.text, x, cy + size * 0.35, size, 'left');
        x += tw + gap;
      }
    });
  }

  /* Splits the built titles into reusable segment groups. */
  function buildSegments(bt) {
    return {
      query: bt.queryLine ? [{ type: 'text', text: bt.queryLine }] : [],
      set: bt.setLine ? [{ type: 'text', text: bt.setLine }] : [],
      chips: (bt.chips || []).map(function (c) { return { type: 'chip', chip: c }; }),
      price: bt.priceLine ? [{ type: 'text', text: bt.priceLine }] : []
    };
  }

  /* ═══════════════════════════════════════════════════════════════
     STYLED GOLD TEXT HELPER
     ═══════════════════════════════════════════════════════════════ */

  function drawStyledGoldText(ctx, text, x, y, fontSize, align) {
    align = align || 'left';

    // A non-finite x kills createLinearGradient and rejects the whole sheet
    // promise, which silently stalls the ZIP — the button says "Listo" and
    // nothing downloads. Fail visible, not fatal.
    if (!isFinite(x) || !isFinite(y) || !isFinite(fontSize)) {
      console.warn('[export] drawStyledGoldText got non-finite geometry',
        { text: text, x: x, y: y, fontSize: fontSize });
      return 0;
    }

    var scale = fontSize / 80;

    ctx.font = 'bold ' + fontSize + 'px "Arial Black", Arial, sans-serif';
    ctx.textAlign = align;
    ctx.textBaseline = 'alphabetic';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    // Layer 1: Deep black shadow
    ctx.lineWidth = 12 * scale;
    ctx.strokeStyle = '#000000';
    ctx.globalAlpha = 0.95;
    ctx.strokeText(text, x + 4 * scale, y + 4 * scale);

    // Layer 2: Dark red/maroon stroke
    ctx.lineWidth = 9 * scale;
    ctx.strokeStyle = '#8B0000';
    ctx.globalAlpha = 1;
    ctx.strokeText(text, x, y);

    // Layer 3: Bright yellow stroke
    ctx.lineWidth = 6 * scale;
    ctx.strokeStyle = '#FFFF00';
    ctx.strokeText(text, x, y);

    // Layer 4: Gold fill
    var textWidth = ctx.measureText(text).width;
    var gradX0, gradX1;
    if (align === 'left') { gradX0 = x; gradX1 = x + textWidth; }
    else if (align === 'right') { gradX0 = x - textWidth; gradX1 = x; }
    else { gradX0 = x - textWidth / 2; gradX1 = x + textWidth / 2; }

    var gradient = ctx.createLinearGradient(gradX0, y - 60 * scale, gradX1, y + 60 * scale);
    gradient.addColorStop(0, '#FFD700');
    gradient.addColorStop(0.5, '#FFA500');
    gradient.addColorStop(1, '#FF8C00');
    ctx.fillStyle = gradient;
    ctx.fillText(text, x, y);

    // Layer 5: Bright yellow highlight
    ctx.lineWidth = 2 * scale;
    ctx.strokeStyle = 'rgba(255, 255, 0, 0.8)';
    ctx.globalAlpha = 0.8;
    ctx.strokeText(text, x - 1, y - 1);

    ctx.globalAlpha = 1;

    return textWidth;
  }

  /* ═══════════════════════════════════════════════════════════════
     COLLAGE TITLE BLOCK — three stacked rows
     ═══════════════════════════════════════════════════════════════ */

  function drawTitle(ctx, canvas, mainTitle, lines, setName, F) {
    var canvasWidth = canvas.width;
    var LOGO_SAFE_X = F.logoSafeX;

    // Centre on the CANVAS, not on the space right of the logo — a permanent
    // offset reads as a mistake even when nothing needs the room.
    var titleX = canvasWidth / 2;
    var titleY = F.titleY;

    // The widest a centred row can be before its left edge crosses the logo.
    var centredMax = (canvasWidth / 2 - LOGO_SAFE_X) * 2;
    var titleAreaWidth = canvasWidth - LOGO_SAFE_X;    // the fallback area

    // Shifts a row right just far enough to clear the logo, and only if it
    // would otherwise run under it. Returns the centre to draw at.
    function safeCentre(width) {
      var left = canvasWidth / 2 - width / 2;
      if (left >= LOGO_SAFE_X) return canvasWidth / 2;      // fits centred
      return LOGO_SAFE_X + width / 2;                        // nudged clear
    }

    // ── ROW 1: main gold title (plus a set label only in 'auto' mode) ──
    var titleFontSize = F.titleMax;
    var setNameText = setName || '';
    var gap = setNameText ? F.setGap : 0;

    while (titleFontSize > F.titleMin) {
      ctx.font = 'bold ' + titleFontSize + 'px "Arial Black", Arial, sans-serif';
      var w = (setNameText ? ctx.measureText(setNameText).width + gap : 0) + ctx.measureText(mainTitle).width;
      if (w <= centredMax - 40) break;
      titleFontSize -= F.titleStep;
    }

    ctx.font = 'bold ' + titleFontSize + 'px "Arial Black", Arial, sans-serif';
    var setNameWidth = setNameText ? ctx.measureText(setNameText).width : 0;
    var mainTitleWidth = ctx.measureText(mainTitle).width;
    var totalWidth = setNameWidth + gap + mainTitleWidth;
    var groupStartX = safeCentre(totalWidth) - totalWidth / 2;

    if (setNameText) {
      drawStyledGoldText(ctx, setNameText, groupStartX, titleY, titleFontSize, 'left');
    }
    drawStyledGoldText(ctx, mainTitle, groupStartX + setNameWidth + gap, titleY, titleFontSize, 'left');

    // ── INFO ROWS: at most two, every segment the same size ───────
    var rows = (lines || []).filter(function (r) { return r && r.length; });
    if (!rows.length) return;

    var maxRowWidth = titleAreaWidth - 40;
    var maxSize = rows.length <= 1 ? F.infoMaxOne : F.infoMaxMulti;
    var rowGap = F.infoRowGap;

    var size = fitRowsSize(ctx, rows, maxRowWidth, maxSize, F.infoMin);

    // Never let the block reach the card area.
    var bandTop = titleY + F.infoBandTop;
    var available = F.titleBlockBottom - bandTop;
    var total = rows.length * size + rowGap * (rows.length - 1);
    if (total > available) {
      size = Math.max(14, Math.floor((available - rowGap * (rows.length - 1)) / rows.length));
      total = rows.length * size + rowGap * (rows.length - 1);
    }

    // Centre the block in the band; y tracks each row's centre.
    var y = bandTop + Math.max(0, (available - total) / 2) + size / 2;

    rows.forEach(function (segs) {
      // Each row centres independently: a short one sits dead centre, a wide
      // one shifts right only as far as the logo forces it.
      var w2 = segmentsWidth(ctx, segs, size);
      drawMixedRow(ctx, segs, safeCentre(w2), y, size);
      y += size + rowGap;
    });
  }

  /* ═══════════════════════════════════════════════════════════════
     GRID THAT SIZES ITSELF
     ═══════════════════════════════════════════════════════════════ */

  var CARD_ASPECT = 838 / 600;

  function computeGridLayout(count, areaW, areaH, showChange, F) {
    var badgeFactor = 0.30;                       // room above for the rank badge
    var infoFactor = showChange ? 0.26 : 0.18;    // room below for price (+ change)
    var extra = badgeFactor + infoFactor;

    var H_GAP = F.hGap;
    var ROW_GAP = F.rowGap;
    var capCols = Math.min(count, F.maxCols || count);

    var best = null;

    for (var cols = 1; cols <= capCols; cols++) {
      var rows = Math.ceil(count / cols);
      var byWidth = (areaW - (cols - 1) * H_GAP) / cols;
      var byHeight = ((areaH - (rows - 1) * ROW_GAP) / rows) / (CARD_ASPECT + extra);
      var w = Math.min(byWidth, byHeight, F.maxImgW);

      if (w <= 12) continue;
      if (!best || w > best.imgWidth + 0.5) best = { cols: cols, rows: rows, imgWidth: w };
    }

    if (!best) best = { cols: capCols, rows: Math.ceil(count / capCols), imgWidth: 60 };

    // A flatter grid wins when it is within 8% of the biggest artwork: three
    // cards on a tall canvas read as a podium row, not as 2 + 1 orphan.
    var floorW = best.imgWidth * 0.92;
    for (var c2 = 1; c2 <= capCols; c2++) {
      var r2 = Math.ceil(count / c2);
      if (r2 >= best.rows) continue;
      var bw2 = (areaW - (c2 - 1) * H_GAP) / c2;
      var bh2 = ((areaH - (r2 - 1) * ROW_GAP) / r2) / (CARD_ASPECT + extra);
      var w2 = Math.min(bw2, bh2, F.maxImgW);
      if (w2 >= floorW) best = { cols: c2, rows: r2, imgWidth: w2 };
    }

    var imgWidth = Math.floor(best.imgWidth);
    var imgHeight = Math.round(imgWidth * CARD_ASPECT);
    var badgeSpace = imgWidth * badgeFactor;
    var infoSpace = imgWidth * infoFactor;
    var rowHeight = badgeSpace + imgHeight + infoSpace;

    return {
      cols: best.cols,
      rows: best.rows,
      imgWidth: imgWidth,
      imgHeight: imgHeight,
      badgeSpace: badgeSpace,
      infoSpace: infoSpace,
      rowHeight: rowHeight,
      gridHeight: best.rows * rowHeight + (best.rows - 1) * ROW_GAP
    };
  }

  /* ═══════════════════════════════════════════════════════════════
     DRAW CARDS GRID - WITH REAL PRICES

     v15: takes an optional `onCells` array. When supplied, the rect of
     every cell (medal + artwork + info box) is pushed onto it. Purely
     additive — nothing about the drawing changed.
     ═══════════════════════════════════════════════════════════════ */

  function drawCardsGrid(ctx, canvas, cards, images, changeData, showChange, F, onCells) {
    var canvasWidth = canvas.width;
    var canvasHeight = canvas.height;

    var cardsStartY = canvasHeight * F.gridTop;
    var footerHeight = F.gridBottomPad;
    var availableHeight = canvasHeight - cardsStartY - footerHeight;
    var availableWidth = canvasWidth - F.gridSidePad * 2;

    var L = computeGridLayout(cards.length, availableWidth, availableHeight, showChange, F);
    var imgWidth = L.imgWidth;
    var imgHeight = L.imgHeight;
    var startY = cardsStartY + Math.max(0, (availableHeight - L.gridHeight) / 2);
    var H_GAP = F.hGap;
    var ROW_GAP = F.rowGap;

    // everything that used to be a magic number scales with the artwork
    var badgeRadius = Math.max(16, imgWidth * 0.14);
    var rankFontSize = Math.max(15, Math.round(imgWidth * 0.14));
    var priceFontSize = Math.max(14, Math.min(46, Math.round(imgWidth * 0.12)));

    cards.forEach(function (card, cardIdx) {
      var row = Math.floor(cardIdx / L.cols);
      var col = cardIdx % L.cols;

      // centre a short last row instead of leaving it hanging left
      var inThisRow = Math.min(L.cols, cards.length - row * L.cols);
      var rowWidth = inThisRow * imgWidth + (inThisRow - 1) * H_GAP;
      var startX = (canvasWidth - rowWidth) / 2;

      var x = startX + col * (imgWidth + H_GAP);
      var y = startY + row * (L.rowHeight + ROW_GAP) + L.badgeSpace;

      var img = images[cardIdx];

      // ════ IMAGE WITH PROPER ASPECT RATIO (cover fit, clipped) ════
      var displayWidth = imgWidth;
      var displayHeight = imgHeight;

      if (img && img.width && img.height) {
        var aspectRatio = img.width / img.height;
        var containerAspect = imgWidth / imgHeight;

        if (aspectRatio > containerAspect) {
          displayWidth = imgHeight * aspectRatio;
          displayHeight = imgHeight;
        } else {
          displayWidth = imgWidth;
          displayHeight = imgWidth / aspectRatio;
        }
      }

      var imgDisplayX = x + (imgWidth - displayWidth) / 2;
      var imgDisplayY = y + (imgHeight - displayHeight) / 2;

      // Shadow behind image
      ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
      ctx.fillRect(x - 1, y - 1, imgWidth + 2, imgHeight + 2);

      // Golden border
      ctx.strokeStyle = '#FFD700';
      ctx.lineWidth = 2;
      ctx.strokeRect(x, y, imgWidth, imgHeight);

      // Draw image
      if (img) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(x, y, imgWidth, imgHeight);
        ctx.clip();
        ctx.drawImage(img, imgDisplayX, imgDisplayY, displayWidth, displayHeight);
        ctx.restore();
      } else {
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        ctx.fillRect(x, y, imgWidth, imgHeight);
      }

      // ════ RANK BADGE (TOP CENTER) ════
      var badgeX = x + imgWidth / 2;
      var badgeY = y - badgeRadius - 2;

      var displayRank = card.rank;
      var medalColor1 = '#CC0000';  // Default RED
      var medalColor2 = '#990000';
      var medalColor3 = '#660000';
      var strokeColor1 = '#FF6666';

      if (displayRank === 1) {
        medalColor1 = '#FFD700';
        medalColor2 = '#FFA500';
        medalColor3 = '#FF8C00';
        strokeColor1 = '#FFFF00';
      } else if (displayRank === 2) {
        medalColor1 = '#E8E8E8';
        medalColor2 = '#C0C0C0';
        medalColor3 = '#A8A8A8';
        strokeColor1 = '#FFFFFF';
      } else if (displayRank === 3) {
        medalColor1 = '#CD7F32';
        medalColor2 = '#B87333';
        medalColor3 = '#9A6B2A';
        strokeColor1 = '#E8B88F';
      }

      var badgeGradient = ctx.createLinearGradient(badgeX - badgeRadius, badgeY - badgeRadius, badgeX + badgeRadius, badgeY + badgeRadius);
      badgeGradient.addColorStop(0, medalColor1);
      badgeGradient.addColorStop(0.5, medalColor2);
      badgeGradient.addColorStop(1, medalColor3);

      ctx.fillStyle = badgeGradient;
      ctx.beginPath();
      ctx.arc(badgeX, badgeY, badgeRadius, 0, Math.PI * 2);
      ctx.fill();

      ctx.strokeStyle = 'rgba(0, 0, 0, 0.6)';
      ctx.lineWidth = Math.max(3, badgeRadius * 0.18);
      ctx.beginPath();
      ctx.arc(badgeX, badgeY, badgeRadius + 2, 0, Math.PI * 2);
      ctx.stroke();

      ctx.strokeStyle = 'rgba(255, 255, 255, 0.4)';
      ctx.lineWidth = Math.max(2, badgeRadius * 0.11);
      ctx.beginPath();
      ctx.arc(badgeX, badgeY, badgeRadius - Math.max(3, badgeRadius * 0.11), 0, Math.PI * 2);
      ctx.stroke();

      ctx.strokeStyle = strokeColor1;
      ctx.lineWidth = Math.max(2, badgeRadius * 0.07);
      ctx.beginPath();
      ctx.arc(badgeX, badgeY, badgeRadius, 0, Math.PI * 2);
      ctx.stroke();

      ctx.font = 'bold ' + rankFontSize + 'px "Arial Black", Arial, sans-serif';
      ctx.fillStyle = '#FFFFFF';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      ctx.shadowColor = 'rgba(0, 0, 0, 0.9)';
      ctx.shadowBlur = 8;
      ctx.shadowOffsetX = 3;
      ctx.shadowOffsetY = 4;
      ctx.fillText('#' + displayRank, badgeX, badgeY);

      ctx.shadowColor = 'rgba(255, 255, 255, 0.6)';
      ctx.shadowBlur = 4;
      ctx.shadowOffsetX = -1;
      ctx.shadowOffsetY = -1;
      ctx.fillText('#' + displayRank, badgeX, badgeY);

      ctx.shadowColor = 'transparent';
      ctx.shadowBlur = 0;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;

      // ════ INFO BELOW IMAGE - REAL PRICE FROM CARD DATA ════
      var infoBoxHeight = L.infoSpace + (showChange ? 8 : 4);
      var infoBoxY = y + imgHeight + 6;
      var infoBoxX = x - 1;
      var infoBoxWidth = imgWidth + 2;

      ctx.fillStyle = 'rgba(20, 20, 40, 0.75)';
      ctx.fillRect(infoBoxX, infoBoxY, infoBoxWidth, infoBoxHeight);

      ctx.strokeStyle = '#FFD700';
      ctx.lineWidth = 2;
      ctx.strokeRect(infoBoxX, infoBoxY, infoBoxWidth, infoBoxHeight);

      ctx.strokeStyle = 'rgba(255, 255, 0, 0.6)';
      ctx.lineWidth = 1;
      ctx.strokeRect(infoBoxX + 1, infoBoxY + 1, infoBoxWidth - 2, infoBoxHeight - 2);

      // ★★★ REAL PRICE — stroked, not glowed ★★★
      // MXN only here: the cells are narrow, so a two-currency line would
      // shrink past legibility. USD lives on the individual sheets.
      var formattedPrice = money(card.price);
      var cellPriceX = x + imgWidth / 2;
      var cellPriceY = infoBoxY + (showChange ? infoBoxHeight * 0.34 : infoBoxHeight / 2);

      // shrink to fit the cell rather than overflowing it
      var cellPxSize = priceFontSize;
      ctx.font = 'bold ' + cellPxSize + 'px "Arial Black", Arial, sans-serif';
      while (cellPxSize > 11 && ctx.measureText(formattedPrice).width > infoBoxWidth - 12) {
        cellPxSize -= 1;
        ctx.font = 'bold ' + cellPxSize + 'px "Arial Black", Arial, sans-serif';
      }
      var cellScale = cellPxSize / 36;

      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      ctx.lineWidth = Math.max(3, 7 * cellScale);
      ctx.strokeStyle = '#000000';
      ctx.globalAlpha = 0.9;
      ctx.strokeText(formattedPrice, cellPriceX + 1.5 * cellScale, cellPriceY + 1.5 * cellScale);

      ctx.lineWidth = Math.max(2.2, 5 * cellScale);
      ctx.strokeStyle = '#3A2000';
      ctx.globalAlpha = 1;
      ctx.strokeText(formattedPrice, cellPriceX, cellPriceY);

      var cellGrad = ctx.createLinearGradient(
        cellPriceX, cellPriceY - cellPxSize * 0.6,
        cellPriceX, cellPriceY + cellPxSize * 0.6
      );
      cellGrad.addColorStop(0, '#FFF3B0');
      cellGrad.addColorStop(0.5, '#FFD700');
      cellGrad.addColorStop(1, '#FFA500');
      ctx.fillStyle = cellGrad;
      ctx.fillText(formattedPrice, cellPriceX, cellPriceY);

      ctx.lineWidth = Math.max(0.8, 1.2 * cellScale);
      ctx.strokeStyle = 'rgba(255, 250, 200, 0.75)';
      ctx.globalAlpha = 0.8;
      ctx.strokeText(formattedPrice, cellPriceX - 0.4, cellPriceY - 0.4);
      ctx.globalAlpha = 1;

      // ★★★ CHANGE PILL ▲ +18.4% / ▼ -13.1% ★★★
      if (showChange && changeData && changeData.changes && changeData.changes[cardIdx] != null) {
        var pillHeight = Math.max(18, Math.min(46, infoBoxHeight * 0.42));
        drawChangePill(ctx, x + imgWidth / 2, infoBoxY + infoBoxHeight * 0.72,
                       changeData.changes[cardIdx], pillHeight);
      }

      // ════ v15: cell rect for the video path ════
      // Padded a few px so the medal's outer stroke and the info box's
      // shadow are not clipped at the crop edge.
      if (onCells) {
        var cellTop = badgeY - badgeRadius - 4;
        onCells.push({
          x: Math.max(0, Math.floor(x - 3)),
          y: Math.max(0, Math.floor(cellTop)),
          w: Math.ceil(imgWidth + 6),
          h: Math.ceil((infoBoxY + infoBoxHeight + 4) - cellTop)
        });
      }
    });

    // Footer
    ctx.shadowBlur = 0;
    var footerY = canvasHeight - F.footerBaseline;
    ctx.fillStyle = 'rgba(20, 20, 40, 0.85)';
    ctx.fillRect(0, canvasHeight - F.footerH, canvasWidth, F.footerH);

    ctx.font = 'bold ' + F.footerFont + 'px Arial';
    ctx.fillStyle = 'rgba(255, 255, 255, 0.92)';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.fillText('NENSONS Market Watch • ' + getSpanishDateString() + ' • WWW.NENSONS.COM', canvasWidth / 2, footerY);
  }

  /* ═══════════════════════════════════════════════════════════════
     INDIVIDUAL CARD (DETAILED, LARGER) - WITH REAL PRICE

     v15: `opts` is optional and changes nothing when omitted.
       opts.transparent   skip the background — the motion pass slices
                          this version into bands
       opts.onGeometry    called with the y-coordinates this function
                          already computes, so the video path never has
                          to guess at a layout the drawing code owns
     ═══════════════════════════════════════════════════════════════ */

  function createIndividualCard(bgImg, card, cardImg, rank, titleData, showChange, F, opts) {
    return new Promise(function(resolve) {
      opts = opts || {};

      var canvas = document.createElement('canvas');
      canvas.width = F.W;
      canvas.height = F.H;
      var ctx = canvas.getContext('2d');
      var LOGO_SAFE_X = F.logoSafeX;

      // ════ BACKGROUND ════
      // The plate carries this on the motion pass, at the same 10%.
      if (!opts.transparent) {
        drawCover(ctx, bgImg, canvas.width, canvas.height);
        ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }

      // ★★★ BUILD DYNAMIC TITLES ★★★
      var builtTitles = buildTitles(titleData);
      var displayMainTitle = builtTitles.mainTitle.replace('TOP ', '').replace(' ▲', '').replace(' ▼', '');
      // a single sheet is one card, so the count becomes a word
      if (/^\d+$/.test(displayMainTitle.trim())) displayMainTitle = 'CARD';
      // …and the plural section names become singular
      else if (displayMainTitle === 'GANADORES') displayMainTitle = 'GANADOR';
      else if (displayMainTitle === 'PERDEDORES') displayMainTitle = 'PERDEDOR';

      // ════ MAIN TITLE + SET NAME TOGETHER, SAME ROW, SAME SIZE ════
      var titleAreaW = canvas.width - LOGO_SAFE_X;
      var titleX = canvas.width / 2;
      var cardCentredMax = (canvas.width / 2 - LOGO_SAFE_X) * 2;

      function safeCentre(width) {
        var left = canvas.width / 2 - width / 2;
        return left >= LOGO_SAFE_X ? canvas.width / 2 : LOGO_SAFE_X + width / 2;
      }

      var titleY = F.s_titleY;
      var cardTitleFontSize = F.s_titleMax;
      var cardMainTitleText = 'TOP ' + displayMainTitle;
      var cardSetNameText = builtTitles.setName || '';
      var cardGap = cardSetNameText ? F.s_setGap : 0;

      while (cardTitleFontSize > F.s_titleMin) {
        ctx.font = 'bold ' + cardTitleFontSize + 'px "Arial Black", Arial, sans-serif';
        var tw = (cardSetNameText ? ctx.measureText(cardSetNameText).width + cardGap : 0) +
                 ctx.measureText(cardMainTitleText).width;
        if (tw <= cardCentredMax - 40) break;
        cardTitleFontSize -= F.s_titleStep;
      }

      ctx.font = 'bold ' + cardTitleFontSize + 'px "Arial Black", Arial, sans-serif';
      var cardSetNameWidth = cardSetNameText ? ctx.measureText(cardSetNameText).width : 0;
      var cardMainTitleWidth = ctx.measureText(cardMainTitleText).width;
      var cardTotalWidth = cardSetNameWidth + cardGap + cardMainTitleWidth;
      var cardGroupStartX = safeCentre(cardTotalWidth) - cardTotalWidth / 2;

      if (cardSetNameText) {
        drawStyledGoldText(ctx, cardSetNameText, cardGroupStartX, titleY, cardTitleFontSize, 'left');
      }
      var cardMainTitleX = cardGroupStartX + cardSetNameWidth + cardGap;
      drawStyledGoldText(ctx, cardMainTitleText, cardMainTitleX, titleY, cardTitleFontSize, 'left');

      // ════ INFO ROWS ════
      // Everything on ONE row — sets, chips, price — unless the sets make it
      // too cramped, in which case sets take their own row and the chips +
      // price sit beneath them (chips first).
      var cardSeg = buildSegments(builtTitles);
      var oneRow = cardSeg.query.concat(cardSeg.set, cardSeg.chips, cardSeg.price);
      var infoMaxWidth = titleAreaW - 40;
      var infoRows = [];

      if (oneRow.length) {
        var oneSize = fitRowsSize(ctx, [oneRow], infoMaxWidth, F.s_infoMax, 12);
        if (oneSize >= F.s_infoOneRowMin || !cardSeg.set.length) {
          infoRows = [oneRow];
        } else {
          infoRows = [cardSeg.query.concat(cardSeg.set), cardSeg.chips.concat(cardSeg.price)]
            .filter(function (r) { return r.length; });
        }
      } else if (builtTitles.fallbackLine) {
        infoRows = [[{ type: 'text', text: builtTitles.fallbackLine }]];
      }

      var infoBottom = titleY + 24;
      var infoSize = Math.round(F.s_infoMax * 0.7);   // fallback when there are no info rows
      if (infoRows.length) {
        infoSize = fitRowsSize(ctx, infoRows, infoMaxWidth, F.s_infoMax, F.s_infoMin);
        var infoGap = F.s_infoGap;
        var infoY = titleY + F.s_infoOffset + infoSize / 2;

        infoRows.forEach(function (segs) {
          var rowW = segmentsWidth(ctx, segs, infoSize);
          drawMixedRow(ctx, segs, safeCentre(rowW), infoY, infoSize);
          infoY += infoSize + infoGap;
        });

        infoBottom = infoY - infoGap - infoSize / 2;
      }

      // ════ PRODUCT TITLE BELOW ════
      var productTitle = card.name || card.ticker || 'Card';

      var nameSize = infoSize;
      var maxTitleWidth = titleAreaW - 60;
      var titleCenterX = titleX;
      var titleLineY = infoBottom + F.s_nameOffset + nameSize / 2;

      ctx.font = 'bold ' + nameSize + 'px "Arial Black", Arial, sans-serif';
      var nameLines = [productTitle];

      if (ctx.measureText(productTitle).width >= maxTitleWidth) {
        var words = productTitle.split(' ');
        var splitPoint = Math.ceil(words.length / 2);
        nameLines = [
          words.slice(0, splitPoint).join(' '),
          words.slice(splitPoint).join(' ')
        ];
      }

      nameLines.forEach(function (line, i) {
        drawElegant3DText(ctx, line, titleCenterX, titleLineY + i * (nameSize + F.s_nameLineGap), nameSize, 'center');
      });

      // Everything above the artwork ends here.
      var headerBottom = titleLineY + (nameLines.length - 1) * (nameSize + F.s_nameLineGap) + nameSize * 0.4;

      // ════ LARGE IMAGE ════
      // imgY follows the header instead of sitting at a fixed offset, so a
      // tall info block pushes the artwork down rather than letting the
      // product name land on top of the rank badge.
      var CARD_BADGE_RADIUS = F.s_badgeR;
      var ART_BOTTOM = F.s_artBottom;

      var badgeCenterY = headerBottom + 16 + CARD_BADGE_RADIUS;
      var maxImgWidth = F.s_artW;
      var imgY = Math.max(F.s_artMinY, badgeCenterY + F.s_badgeGap);
      var maxImgHeight = Math.max(F.s_artMinH, ART_BOTTOM - imgY);

      badgeCenterY = imgY - F.s_badgeGap;          // re-sync after the clamp

      // contain fit inside the reserved box
      var displayWidth = maxImgWidth;
      var displayHeight = maxImgHeight;

      if (cardImg && cardImg.width && cardImg.height) {
        var aspectRatio = cardImg.width / cardImg.height;
        var containerAspect = maxImgWidth / maxImgHeight;

        if (aspectRatio > containerAspect) {
          displayWidth = maxImgWidth;
          displayHeight = maxImgWidth / aspectRatio;
        } else {
          displayWidth = maxImgHeight * aspectRatio;
          displayHeight = maxImgHeight;
        }
      }

      // The gold frame either hugs the art (no background bars inside it) or
      // keeps the full reserved box, as v13 did.
      var frameW = FRAME_HUGS_ART ? displayWidth : maxImgWidth;
      var frameH = FRAME_HUGS_ART ? displayHeight : maxImgHeight;
      var frameX = (canvas.width - frameW) / 2;
      var frameY = imgY;

      var imgDisplayX = frameX + (frameW - displayWidth) / 2;
      var imgDisplayY = frameY + (frameH - displayHeight) / 2;

      // Image border and shadow
      ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
      ctx.fillRect(frameX - 2, frameY - 2, frameW + 4, frameH + 4);

      ctx.strokeStyle = '#FFD700';
      ctx.lineWidth = 4;
      ctx.strokeRect(frameX, frameY, frameW, frameH);

      ctx.strokeStyle = 'rgba(255, 255, 0, 0.6)';
      ctx.lineWidth = 2;
      ctx.strokeRect(frameX + 2, frameY + 2, frameW - 4, frameH - 4);

      // Draw image with clipping
      if (cardImg) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(frameX, frameY, frameW, frameH);
        ctx.clip();
        ctx.drawImage(cardImg, imgDisplayX, imgDisplayY, displayWidth, displayHeight);
        ctx.restore();
      } else {
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        ctx.fillRect(frameX, frameY, frameW, frameH);
      }

      // ════ RANK BADGE CIRCLE ════
      var badgeRadius = CARD_BADGE_RADIUS;
      var badgeX = canvas.width / 2;
      var badgeY = badgeCenterY;

      var displayRank = rank;

      var medalColor1 = '#CC0000';  // Default RED
      var medalColor2 = '#990000';
      var medalColor3 = '#660000';
      var strokeColor1 = '#FF6666';

      if (displayRank === 1) {
        medalColor1 = '#FFD700';
        medalColor2 = '#FFA500';
        medalColor3 = '#FF8C00';
        strokeColor1 = '#FFFF00';
      } else if (displayRank === 2) {
        medalColor1 = '#E8E8E8';
        medalColor2 = '#C0C0C0';
        medalColor3 = '#A8A8A8';
        strokeColor1 = '#FFFFFF';
      } else if (displayRank === 3) {
        medalColor1 = '#CD7F32';
        medalColor2 = '#B87333';
        medalColor3 = '#9A6B2A';
        strokeColor1 = '#E8B88F';
      }

      var badgeGradient = ctx.createLinearGradient(badgeX - badgeRadius, badgeY - badgeRadius, badgeX + badgeRadius, badgeY + badgeRadius);
      badgeGradient.addColorStop(0, medalColor1);
      badgeGradient.addColorStop(0.5, medalColor2);
      badgeGradient.addColorStop(1, medalColor3);

      ctx.fillStyle = badgeGradient;
      ctx.beginPath();
      ctx.arc(badgeX, badgeY, badgeRadius, 0, Math.PI * 2);
      ctx.fill();

      ctx.strokeStyle = 'rgba(0, 0, 0, 0.6)';
      ctx.lineWidth = Math.max(4, badgeRadius * 0.15);
      ctx.beginPath();
      ctx.arc(badgeX, badgeY, badgeRadius + 2, 0, Math.PI * 2);
      ctx.stroke();

      ctx.strokeStyle = 'rgba(255, 255, 255, 0.4)';
      ctx.lineWidth = Math.max(3, badgeRadius * 0.1);
      ctx.beginPath();
      ctx.arc(badgeX, badgeY, badgeRadius - Math.max(4, badgeRadius * 0.1), 0, Math.PI * 2);
      ctx.stroke();

      ctx.strokeStyle = strokeColor1;
      ctx.lineWidth = Math.max(2, badgeRadius * 0.075);
      ctx.beginPath();
      ctx.arc(badgeX, badgeY, badgeRadius, 0, Math.PI * 2);
      ctx.stroke();

      ctx.font = 'bold ' + F.s_badgeFont + 'px "Arial Black", Arial, sans-serif';
      ctx.fillStyle = '#FFFFFF';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      ctx.shadowColor = 'rgba(0, 0, 0, 0.9)';
      ctx.shadowBlur = 10;
      ctx.shadowOffsetX = 4;
      ctx.shadowOffsetY = 5;
      ctx.fillText('#' + displayRank, badgeX, badgeY);

      ctx.shadowColor = 'rgba(255, 255, 255, 0.6)';
      ctx.shadowBlur = 5;
      ctx.shadowOffsetX = -2;
      ctx.shadowOffsetY = -2;
      ctx.fillText('#' + displayRank, badgeX, badgeY);

      ctx.shadowColor = 'transparent';
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;

      // ════ PRICE BELOW IMAGE ════
      // The BOX grows to fit the price, not the other way round.
      var hasChange = showChange && typeof card.change === 'number' && !isNaN(card.change);
      var priceText = priceLabel(card.price);

      var priceBoxHeight = F.s_priceBoxH;
      var priceBoxTop = frameY + frameH + F.s_priceGap;

      // never let the box slide under the footer bar
      var priceLimit = canvas.height - F.s_footerH - 6 - priceBoxHeight;
      if (priceBoxTop > priceLimit) priceBoxTop = priceLimit;

      var priceTextY = priceBoxTop + priceBoxHeight / 2;

      var sheetPxSize = F.s_priceSize;
      var pillH = F.s_pillH;

      ctx.font = 'bold ' + sheetPxSize + 'px "Arial Black", Arial, sans-serif';
      var pillProbe = hasChange ? changePillWidth(ctx, card.change, pillH) + F.s_groupGap : 0;

      // What the content actually needs, then the box that holds it.
      var needed = ctx.measureText(priceText).width + pillProbe + 48;
      var priceBoxWidth = Math.min(F.s_priceBoxMaxW, Math.max(frameW, needed));

      // Only shrink once the box has hit its own ceiling.
      ctx.font = 'bold ' + sheetPxSize + 'px "Arial Black", Arial, sans-serif';
      while (sheetPxSize > F.s_priceMin &&
             ctx.measureText(priceText).width + pillProbe > priceBoxWidth - 24) {
        sheetPxSize -= 1;
        ctx.font = 'bold ' + sheetPxSize + 'px "Arial Black", Arial, sans-serif';
        pillProbe = hasChange ? changePillWidth(ctx, card.change, pillH) + F.s_groupGap : 0;
      }

      var priceBoxX = (canvas.width - priceBoxWidth) / 2;   // centred, not tied to the art

      ctx.fillStyle = 'rgba(20, 20, 40, 0.75)';
      ctx.fillRect(priceBoxX, priceBoxTop, priceBoxWidth, priceBoxHeight);

      ctx.strokeStyle = '#FFD700';
      ctx.lineWidth = 3;
      ctx.strokeRect(priceBoxX, priceBoxTop, priceBoxWidth, priceBoxHeight);

      ctx.strokeStyle = 'rgba(255, 255, 0, 0.6)';
      ctx.lineWidth = 2;
      ctx.strokeRect(priceBoxX + 2, priceBoxTop + 2, priceBoxWidth - 4, priceBoxHeight - 4);

      ctx.font = 'bold ' + sheetPxSize + 'px "Arial Black", Arial, sans-serif';
      var priceTextWidth = ctx.measureText(priceText).width;

      var pillW = hasChange ? changePillWidth(ctx, card.change, pillH) : 0;
      var groupGap = hasChange ? F.s_groupGap : 0;
      var groupWidth = priceTextWidth + groupGap + pillW;
      var groupLeft = canvas.width / 2 - groupWidth / 2;

      // Stroked like the gold title rather than flat-filled: a gold glow on
      // gold text has nothing to hold its edge, so it dissolves into bright
      // artwork. Dark strokes first, then the fill, then a thin highlight.
      var priceScale = sheetPxSize / 36;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';

      // deep shadow, offset — gives the type physical weight
      ctx.lineWidth = 7 * priceScale;
      ctx.strokeStyle = '#000000';
      ctx.globalAlpha = 0.9;
      ctx.strokeText(priceText, groupLeft + 2 * priceScale, priceTextY + 2 * priceScale);

      // the edge itself
      ctx.lineWidth = 5 * priceScale;
      ctx.strokeStyle = '#3A2000';
      ctx.globalAlpha = 1;
      ctx.strokeText(priceText, groupLeft, priceTextY);

      // gold fill, top-lit
      var priceGrad = ctx.createLinearGradient(
        groupLeft, priceTextY - sheetPxSize * 0.6,
        groupLeft, priceTextY + sheetPxSize * 0.6
      );
      priceGrad.addColorStop(0, '#FFF3B0');
      priceGrad.addColorStop(0.5, '#FFD700');
      priceGrad.addColorStop(1, '#FFA500');
      ctx.fillStyle = priceGrad;
      ctx.fillText(priceText, groupLeft, priceTextY);

      // thin bright rim, catches the eye without softening the edge
      ctx.lineWidth = 1.2 * priceScale;
      ctx.strokeStyle = 'rgba(255, 250, 200, 0.75)';
      ctx.globalAlpha = 0.8;
      ctx.strokeText(priceText, groupLeft - 0.5, priceTextY - 0.5);
      ctx.globalAlpha = 1;

      if (hasChange) {
        drawChangePill(ctx, groupLeft + priceTextWidth + groupGap + pillW / 2, priceTextY, card.change, pillH);
      }

      // ════ FOOTER ════
      ctx.fillStyle = 'rgba(20, 20, 40, 0.85)';
      ctx.fillRect(0, canvas.height - F.s_footerH, canvas.width, F.s_footerH);

      ctx.font = 'bold ' + F.s_footerFont + 'px Arial';
      ctx.fillStyle = 'rgba(255, 255, 255, 0.92)';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'alphabetic';
      ctx.fillText('NENSONS Market Watch • ' + getSpanishDateString() + ' • WWW.NENSONS.COM',
                   canvas.width / 2, canvas.height - F.s_footerBaseline);

      // ════ v15: where the band cuts go ════
      // All of it is computed above already; this only exposes it.
      if (opts.onGeometry) {
        opts.onGeometry({
          titleY: titleY,
          infoBottom: infoBottom,
          nameBottom: headerBottom,
          badgeY: badgeCenterY,
          badgeR: CARD_BADGE_RADIUS,
          frameY: frameY,
          frameH: frameH,
          priceTop: priceBoxTop,
          priceH: priceBoxHeight,
          footerTop: canvas.height - F.s_footerH
        });
      }

      resolve(canvas);
    });
  }

  /* ═══════════════════════════════════════════════════════════════
     ░░ BLOCK A ░░  — VIDEO CONFIG, EASING, TRANSITIONS
     ═══════════════════════════════════════════════════════════════ */

  /* Session choice, same lifetime as exportFormat. */
  var outputMode = 'zip';        // 'zip' | 'mp4'

  /* ── Timing and feel ──────────────────────────────────────────
     Seconds. A 10-card export at these numbers runs about 32s,
     which sits inside the Reels / Shorts sweet spot.

       holdCollage   the cover frame, held longer than the rest
       holdCard      each individual sheet
       trans         one transition — a slide needs more room than a
                     dissolve does, so this is longer than it looks
       tail          extra beat on the last frame before the outro
       endCard       true = return to the collage to close
       kenBurns      total zoom across a scene's life (0.04 = 4%)
                     set to 0 for a pure lateral glide

     ── slide feel ──
       slideEase     cubic-bezier control points, same as CSS. Must
                     leave quickly and settle slowly. Keep y2 at 1.0
                     or below: a bounce curve pulls the incoming sheet
                     past its slot and exposes what is behind it for a
                     frame.
       slideBreathe  the strip eases back a touch mid-move, like a
                     camera pulling out to travel. Under 0.03.
       slideShadow   how hard the incoming sheet's edge shadows the
                     one it covers. 0 removes the depth cue.
       slideSeam     gold hairline on that edge. 0 to remove.
  */
  var VIDEO = {
    fps:         30,
    holdCollage: 2.6,
    holdCard:    2.0,
    trans:       0.75,
    tail:        0.9,
    endCard:     true,
    holdEndCard: 1.8,
    fadeIn:      0.45,
    fadeOut:     0.7,
    kenBurns:    0.04,
    kenBurnsOut: true,
    bitrate:     12000000,        // 12 Mbps — clean at 1080 vertical
    transition:  'slide',         // 'slide' | 'dissolve' | 'sweep' | 'push' | 'auto'

    // v15 FIX. v14 shipped [0.50, 0.03, 0.16, 1.0], which is an ease-IN:
    // y1 = 0.03 at x1 = 0.50 means the strip barely moves for the first
    // third of the transition and then rushes — the opposite of what the
    // comment above describes, and the reason each slide landed flat.
    // This is cubic-bezier(.22, 1, .36, 1), the curve on nearly every
    // transition in exchange-board.css.
    slideEase:    [0.22, 1, 0.36, 1],
    slideBreathe: 0.02,
    slideShadow:  0.45,
    slideSeam:    0.30
  };

  /* mp4-muxer. Pinned on purpose: the muxer API changed shape
     between majors, and an unpinned CDN URL is a silent breakage
     waiting for a release you didn't ask for. */
  var MUXER_URL = 'https://cdn.jsdelivr.net/npm/mp4-muxer@5.2.1/build/mp4-muxer.min.js';

  var muxerLib = null;

  function loadMuxer() {
    return new Promise(function (resolve) {
      if (muxerLib) { resolve(muxerLib); return; }
      if (window.Mp4Muxer) { muxerLib = window.Mp4Muxer; resolve(muxerLib); return; }

      var s = document.createElement('script');
      s.src = MUXER_URL;
      s.onload = function () { muxerLib = window.Mp4Muxer || null; resolve(muxerLib); };
      s.onerror = function () {
        console.error('[video] mp4-muxer failed to load');
        resolve(null);
      };
      document.head.appendChild(s);
    });
  }

  /* ── Easing ───────────────────────────────────────────────────
     Nothing here is linear. Linear motion is the single clearest
     tell that a slideshow was generated rather than cut. */

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function easeOutQuint(t) {
    return 1 - Math.pow(1 - t, 5);
  }

  function clamp01(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }

  /* Cubic-bezier timing, the same curve CSS uses. Newton-Raphson, six
     iterations — plenty at 30fps. Having the curve as data rather than a
     named function is what lets the feel be tuned from the console. */
  function cubicBezier(x1, y1, x2, y2) {
    function A(a, b) { return 1 - 3 * b + 3 * a; }
    function B(a, b) { return 3 * b - 6 * a; }
    function C(a)    { return 3 * a; }
    function calc(t, a, b)  { return ((A(a, b) * t + B(a, b)) * t + C(a)) * t; }
    function slope(t, a, b) { return 3 * A(a, b) * t * t + 2 * B(a, b) * t + C(a); }

    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 6; i++) {
        var s = slope(t, x1, x2);
        if (s === 0) break;
        t -= (calc(t, x1, x2) - x) / s;
      }
      return calc(t, y1, y2);
    };
  }

  var _easeFn = null;
  var _easeKey = '';

  function slideEase(t) {
    var key = VIDEO.slideEase.join(',');
    if (key !== _easeKey) {
      _easeKey = key;
      _easeFn = cubicBezier(VIDEO.slideEase[0], VIDEO.slideEase[1],
                            VIDEO.slideEase[2], VIDEO.slideEase[3]);
    }
    return _easeFn(t);
  }

  /* One sheet in one W-wide slot, clipped to that slot. The clip matters:
     a Ken Burns zoom makes the sheet wider than its slot, and without it
     that overflow paints over the neighbouring sheet on the strip. */
  function paintSlot(ctx, W, H, src, offsetX, scale) {
    if (!src) return;
    if (offsetX <= -W || offsetX >= W) return;

    ctx.save();
    ctx.beginPath();
    ctx.rect(offsetX, 0, W, H);
    ctx.clip();

    var w = W * scale;
    var h = H * scale;
    ctx.drawImage(src, offsetX + (W - w) / 2, (H - h) / 2, w, h);
    ctx.restore();
  }

  /* ── Scene painter ────────────────────────────────────────────
     Every scene is a full-bleed canvas. Scale is applied about the
     centre so a Ken Burns push never reveals an edge. */

  function paintScene(ctx, W, H, src, scale, dx, dy, alpha) {
    if (!src) return;
    var w = W * scale;
    var h = H * scale;
    ctx.globalAlpha = alpha;
    ctx.drawImage(src, (W - w) / 2 + dx, (H - h) / 2 + dy, w, h);
    ctx.globalAlpha = 1;
  }

  /* ── Transitions ──────────────────────────────────────────────
     Each takes the two scene surfaces, their current Ken Burns
     scales, and t in 0..1. All keep the frame fully covered at
     every instant — no background flash mid-cut. */

  /* Cross-dissolve with a breath of scale. */
  function transDissolve(ctx, W, H, A, B, zA, zB, t) {
    var e = easeInOutCubic(t);
    paintScene(ctx, W, H, A, zA * (1 + 0.030 * e), 0, 0, 1);
    paintScene(ctx, W, H, B, zB * (1 + 0.050 * (1 - e)), 0, 0, e);
  }

  /* Gold sweep. A raked wipe with a lit edge travelling across it —
     the same gold as the frames and the price type, so the motion
     reads as part of the brand rather than a stock wipe. */
  function transSweep(ctx, W, H, A, B, zA, zB, t) {
    var e = easeInOutCubic(t);
    var rake = W * 0.28;                  // horizontal run of the diagonal
    var edge = e * (W + rake);            // x of the boundary at the TOP

    paintScene(ctx, W, H, A, zA, 0, 0, 1);

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(edge, 0);
    ctx.lineTo(edge - rake, H);
    ctx.lineTo(0, H);
    ctx.closePath();
    ctx.clip();
    paintScene(ctx, W, H, B, zB, 0, 0, 1);
    ctx.restore();

    // the lit edge — fades in and out so it never lands hard
    var lit = Math.sin(Math.PI * clamp01(t));
    if (lit > 0.01) {
      var g = ctx.createLinearGradient(edge - W * 0.10, 0, edge + W * 0.02, 0);
      g.addColorStop(0.00, 'rgba(255, 215, 0, 0)');
      g.addColorStop(0.72, 'rgba(255, 215, 0, ' + (0.30 * lit).toFixed(3) + ')');
      g.addColorStop(1.00, 'rgba(255, 247, 200, ' + (0.85 * lit).toFixed(3) + ')');

      ctx.save();
      ctx.globalCompositeOperation = 'lighter';
      ctx.strokeStyle = g;
      ctx.lineWidth = Math.max(3, W * 0.005);
      ctx.shadowColor = 'rgba(255, 200, 60, ' + (0.75 * lit).toFixed(3) + ')';
      ctx.shadowBlur = W * 0.03;
      ctx.beginPath();
      ctx.moveTo(edge, -2);
      ctx.lineTo(edge - rake, H + 2);
      ctx.stroke();
      ctx.restore();
    }
  }

  /* Vertical push with parallax. The outgoing sheet leaves at a
     fraction of the incoming sheet's speed. */
  function transPush(ctx, W, H, A, B, zA, zB, t) {
    var e = easeOutQuint(t);
    paintScene(ctx, W, H, A, zA * (1 + 0.02 * e), 0, -H * 0.14 * e, 1);
    paintScene(ctx, W, H, B, zB, 0, H * (1 - e), 1);

    // hairline seam, gold, dies out as the incoming sheet lands
    var seam = H * (1 - e);
    var a = 0.55 * (1 - e);
    if (a > 0.01 && seam > 0 && seam < H) {
      ctx.save();
      ctx.strokeStyle = 'rgba(255, 215, 0, ' + a.toFixed(3) + ')';
      ctx.lineWidth = Math.max(2, H * 0.0022);
      ctx.shadowColor = 'rgba(255, 190, 40, ' + a.toFixed(3) + ')';
      ctx.shadowBlur = H * 0.02;
      ctx.beginPath();
      ctx.moveTo(0, seam);
      ctx.lineTo(W, seam);
      ctx.stroke();
      ctx.restore();
    }
  }

  /* Continuous push-left. Both sheets share one offset, so they stay
     rigidly one slot apart for the whole move — no parallax, no alpha.
     The moment the two layers move at different speeds the eye reads
     them as separate cards and the continuity is gone. */
  function transSlide(ctx, W, H, A, B, zA, zB, t) {
    var e = slideEase(t);
    var shift = -W * e;

    var breathe = 1 + VIDEO.slideBreathe * Math.sin(Math.PI * clamp01(e));

    paintSlot(ctx, W, H, A, shift,     zA * breathe);
    paintSlot(ctx, W, H, B, shift + W, zB * breathe);

    // Shadow falls LEFT of the seam, onto the sheet being covered — that
    // direction is what sells B as sitting above A rather than beside it.
    var seam = shift + W;
    if (seam <= 0 || seam >= W) return;

    if (VIDEO.slideShadow > 0) {
      var sw = W * 0.06;
      var g = ctx.createLinearGradient(seam - sw, 0, seam, 0);
      g.addColorStop(0, 'rgba(0, 0, 0, 0)');
      g.addColorStop(1, 'rgba(0, 0, 0, ' + VIDEO.slideShadow.toFixed(3) + ')');
      ctx.fillStyle = g;
      ctx.fillRect(seam - sw, 0, sw, H);
    }

    if (VIDEO.slideSeam > 0) {
      var lw = Math.max(2, W * 0.0022);
      ctx.fillStyle = 'rgba(255, 215, 0, ' + VIDEO.slideSeam.toFixed(3) + ')';
      ctx.fillRect(seam - lw, 0, lw, H);
    }
  }

  var TRANS_CYCLE = ['slide'];

  function transitionAt(i) {
    if (VIDEO.transition !== 'auto') return VIDEO.transition;
    return TRANS_CYCLE[i % TRANS_CYCLE.length];
  }

  /* ═══════════════════════════════════════════════════════════════
     ░░ BLOCK D ░░  — ELEMENT MOTION  (new in v15)

     The video no longer slides finished pictures around. Each sheet's
     title, info rows, product name, medal and price box arrive on
     their own beat.

     How, without touching the drawing code:

       1. Each sheet is rendered TWICE — once normally (the canvas the
          ZIP ships), once with the background skipped, giving a
          transparent overlay of everything else.
       2. The overlay is sliced into horizontal bands along the gaps
          the layout already leaves between groups. The cut points come
          from geometry createIndividualCard already computes.
       3. Per frame the composer paints the background plate, then each
          band at its own offset and opacity.

     The bands tile the overlay exactly and every band ends at rest, so
     once a scene's entry has finished the composed frame is identical
     to the original canvas — at which point the composer stops
     compositing and hands back that canvas directly. Steady-state
     frames in the MP4 are the same pixels as the JPEGs in the ZIP, and
     cost nothing to produce.
     ═══════════════════════════════════════════════════════════════ */

  /* ── Feel ─────────────────────────────────────────────────────
     Timings are seconds, measured from the moment a scene's entry
     clock starts. Rise is pixels: every group travels UP into place,
     which is the page's own vocabulary — .view, .ms-pop and
     .export-menu-inner all enter on a short upward translate.

       delay   when this group starts, relative to the scene
       dur     how long it takes; 0 means the group never animates
       rise    px below its resting place it starts
       scale   optional, about the band's own centre

     The stagger is deliberately short. Everything is settled inside
     ~0.85s of a 2.0s hold, so most of every scene is STILL. That
     stillness is what separates elegant from busy — the motion is
     punctuation, not the content.

       lead        how much of the incoming slide the entry overlaps,
                   as a fraction of VIDEO.trans. At 0 the sheet slides
                   in empty and then assembles, which reads as two
                   events. At 0.5 it assembles as it arrives.
       introDelay  the collage waits out most of VIDEO.fadeIn rather
                   than doing its entry underneath a black wash.
       ease        cubic-bezier(.22, 1, .36, 1) — the curve on nearly
                   every transition in exchange-board.css.
  */
  var MOTION = {
    enabled: true,
    lead: 0.5,
    introDelay: 0.25,
    ease: [0.22, 1, 0.36, 1],
    animateEndCard: false,   // the closing collage resolves, it doesn't re-perform

    // ── individual sheet, top to bottom ──
    sheet: {
      title:  { delay: 0.00, dur: 0.55, rise: 16 },
      info:   { delay: 0.07, dur: 0.55, rise: 14 },
      name:   { delay: 0.14, dur: 0.55, rise: 12 },
      // .94 → 1.0 is exactly the crestSwell range in the stylesheet:
      // the medal's largest state is the size it was drawn, so it
      // settles into place rather than punching out of it.
      medal:  { delay: 0.20, dur: 0.60, rise: 0, scale: 0.94 },
      // Same values as a collage cell (rise 10 / dur 0.50), so a card's
      // artwork enters the same way whether it is one of ten on the
      // cover or alone on its own sheet. Slotted after the medal to
      // keep the cascade running strictly top to bottom.
      art:    { delay: 0.24, dur: 0.50, rise: 10 },
      price:  { delay: 0.32, dur: 0.55, rise: 12 },
      footer: { delay: 0.00, dur: 0.00, rise: 0 }   // chrome, never moves
    },

    // ── collage ──
    // Cells reveal in rail order, which IS countdown order: rank is
    // total - idx, so idx 0 is #10 and the last cell to land is #1.
    collage: {
      title:  { delay: 0.00, dur: 0.60, rise: 18 },
      info:   { delay: 0.08, dur: 0.60, rise: 15 },
      cell:   { delay: 0.22, dur: 0.50, rise: 10, stagger: 0.045 },
      footer: { delay: 0.00, dur: 0.00, rise: 0 }
    }
  };

  var _mEaseFn = null;
  var _mEaseKey = '';

  function motionEase(t) {
    var key = MOTION.ease.join(',');
    if (key !== _mEaseKey) {
      _mEaseKey = key;
      _mEaseFn = cubicBezier(MOTION.ease[0], MOTION.ease[1],
                             MOTION.ease[2], MOTION.ease[3]);
    }
    return _mEaseFn(clamp01(t));
  }

  /* ── Band cutting ─────────────────────────────────────────────
     A band is { canvas, x, y, motion }. Bands are cut at the MIDDLE
     of the gap between two groups, never at a group's own edge — the
     gold title carries a 12px stroke and an offset drop shadow, so a
     cut on the glyph box would shear the shadow off. */

  function midCut(a, b) { return b > a ? (a + b) / 2 : b; }

  /* Forces the cut list to increase, so a clamped price box (one that
     has slid up under the footer) can't produce a negative-height
     band. Anything that would invert collapses to zero height and
     drops out. */
  function monotone(cuts, H) {
    var out = [];
    var prev = 0;
    for (var i = 0; i < cuts.length; i++) {
      var v = Math.round(Math.max(prev, Math.min(H, cuts[i])));
      out.push(v);
      prev = v;
    }
    return out;
  }

  function cropBand(overlay, x, y, w, h) {
    var cv = document.createElement('canvas');
    cv.width = Math.max(1, Math.round(w));
    cv.height = Math.max(1, Math.round(h));
    cv.getContext('2d').drawImage(overlay, x, y, cv.width, cv.height,
                                  0, 0, cv.width, cv.height);
    return cv;
  }

  /* Sheet bands, from the geometry createIndividualCard reports. */
  function buildSheetBands(overlay, geo, F) {
    var H = overlay.height;
    var W = overlay.width;

    var cuts = monotone([
      geo.titleY + F.s_infoOffset * 0.45,                    // title | info
      geo.infoBottom + F.s_nameOffset * 0.5,                 // info  | name
      midCut(geo.nameBottom, geo.badgeY - geo.badgeR),       // name  | medal
      midCut(geo.badgeY + geo.badgeR, geo.frameY),           // medal | art
      midCut(geo.frameY + geo.frameH, geo.priceTop),         // art   | price
      midCut(geo.priceTop + geo.priceH, geo.footerTop),      // price | footer
      H
    ], H);

    var names = ['title', 'info', 'name', 'medal', 'art', 'price', 'footer'];
    var bands = [];
    var top = 0;

    names.forEach(function (name, i) {
      var bottom = cuts[i];
      if (bottom - top < 1) { top = bottom; return; }
      bands.push({
        name: name,
        canvas: cropBand(overlay, 0, top, W, bottom - top),
        x: 0,
        y: top,
        motion: MOTION.sheet[name] || { delay: 0, dur: 0, rise: 0 }
      });
      top = bottom;
    });

    return bands;
  }

  /* Collage bands. The cells are lifted out as their own rects and
     then CLEARED from the remainder, so the info band underneath them
     is genuinely empty where a cell used to be — otherwise a cell
     would animate away from a copy of itself. */
  function buildCollageBands(overlay, cellRects, F) {
    var W = overlay.width;
    var H = overlay.height;
    var bands = [];

    var cells = (cellRects || []).map(function (r) {
      return { rect: r, canvas: cropBand(overlay, r.x, r.y, r.w, r.h) };
    });

    var rest = document.createElement('canvas');
    rest.width = W;
    rest.height = H;
    var rctx = rest.getContext('2d');
    rctx.drawImage(overlay, 0, 0);
    cells.forEach(function (c) {
      rctx.clearRect(c.rect.x, c.rect.y, c.rect.w, c.rect.h);
    });

    var titleCut = Math.round(F.titleY + F.infoBandTop * 0.5);
    var footerTop = H - F.footerH;

    bands.push({
      name: 'title',
      canvas: cropBand(rest, 0, 0, W, titleCut),
      x: 0, y: 0,
      motion: MOTION.collage.title
    });

    bands.push({
      name: 'info',
      canvas: cropBand(rest, 0, titleCut, W, footerTop - titleCut),
      x: 0, y: titleCut,
      motion: MOTION.collage.info
    });

    bands.push({
      name: 'footer',
      canvas: cropBand(rest, 0, footerTop, W, H - footerTop),
      x: 0, y: footerTop,
      motion: MOTION.collage.footer
    });

    var cm = MOTION.collage.cell;
    cells.forEach(function (c, i) {
      bands.push({
        name: 'cell' + i,
        canvas: c.canvas,
        x: c.rect.x,
        y: c.rect.y,
        motion: {
          delay: cm.delay + i * cm.stagger,
          dur: cm.dur,
          rise: cm.rise
        }
      });
    });

    return bands;
  }

  function settleTime(bands) {
    var t = 0;
    bands.forEach(function (b) {
      var end = (b.motion.delay || 0) + (b.motion.dur || 0);
      if (end > t) t = end;
    });
    return t;
  }

  /* ── Composition ──────────────────────────────────────────────
     Two scratch buffers, because at most two scenes are on screen at
     once (either side of a transition). Allocating per frame at
     1080×1920 is what turns a 30s render into a GC stall. */

  var _scratch = [null, null];

  function scratchFor(slot, W, H) {
    var c = _scratch[slot];
    if (!c) {
      c = document.createElement('canvas');
      _scratch[slot] = c;
    }
    if (c.width !== W || c.height !== H) { c.width = W; c.height = H; }
    return c;
  }

  function composeScene(scene, local, out) {
    var ctx = out.getContext('2d');
    ctx.clearRect(0, 0, out.width, out.height);

    if (scene.plate) ctx.drawImage(scene.plate, 0, 0);

    scene.bands.forEach(function (b) {
      var m = b.motion;
      var dur = m.dur || 0;
      var p = dur > 0 ? (local - (m.delay || 0)) / dur : 1;

      if (p <= 0) return;                      // not yet — leave the plate bare
      var e = dur > 0 ? motionEase(p) : 1;

      var dy = (m.rise || 0) * (1 - e);
      var a = dur > 0 ? e : 1;

      ctx.globalAlpha = a;

      if (m.scale) {
        var s = m.scale + (1 - m.scale) * e;
        var cx = b.x + b.canvas.width / 2;
        var cy = b.y + b.canvas.height / 2 + dy;
        ctx.save();
        ctx.translate(cx, cy);
        ctx.scale(s, s);
        ctx.drawImage(b.canvas, -b.canvas.width / 2, -b.canvas.height / 2);
        ctx.restore();
      } else {
        ctx.drawImage(b.canvas, b.x, b.y + dy);
      }

      ctx.globalAlpha = 1;
    });

    return out;
  }

  /* The surface renderAt should paint for this scene at this time.
     Returns the ORIGINAL canvas once the entry is over — same pixels,
     no work. */
  function sceneSurface(scene, time, slot, W, H) {
    if (!MOTION.enabled || !scene.bands || !scene.bands.length) return scene.canvas;
    var local = time - scene.motion0;
    if (local >= scene.settleAt) return scene.canvas;
    return composeScene(scene, local, scratchFor(slot, W, H));
  }

  /* Two plates, because the two layouts treat the background
     differently: an individual sheet lays a 10% black wash over it,
     the collage does not. Getting this wrong is invisible until the
     first frame, where the sheet's background is suddenly brighter
     than the JPEG's. */
  function makePlate(bgImg, F, dim) {
    var c = document.createElement('canvas');
    c.width = F.W;
    c.height = F.H;
    var ctx = c.getContext('2d');
    drawCover(ctx, bgImg, F.W, F.H);
    if (dim) {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
      ctx.fillRect(0, 0, F.W, F.H);
    }
    return c;
  }

  function attachMotion(scene, plate, bands) {
    if (!MOTION.enabled || !bands || !bands.length) return scene;
    scene.plate = plate;
    scene.bands = bands;
    scene.settleAt = settleTime(bands);
    return scene;
  }

  /* Everything the composer needs, built once per export. The second
     render pass costs a few ms per sheet — trivial next to encoding,
     and it buys the guarantee that the bands line up with the flat
     canvas exactly, because they came out of the same function. */
  function buildMotionData(bgImg, cards, images, changeData, showChange,
                           titleData, titleText, titleRows, setName, F) {
    var platePlain = makePlate(bgImg, F, false);   // collage
    var plateDim   = makePlate(bgImg, F, true);    // sheets

    // Collage overlay: the same two draw calls the collage already
    // makes, onto a transparent canvas.
    var ov = document.createElement('canvas');
    ov.width = F.W;
    ov.height = F.H;
    var octx = ov.getContext('2d');
    var cellRects = [];

    drawTitle(octx, ov, titleText, titleRows, setName, F);
    drawCardsGrid(octx, ov, cards, images, changeData, showChange, F, cellRects);

    var collageBands = buildCollageBands(ov, cellRects, F);

    var sheetBands = [];
    var jobs = cards.map(function (card, idx) {
      var geo = null;
      return createIndividualCard(
        bgImg, card, images[idx], card.rank, titleData, showChange, F,
        { transparent: true, onGeometry: function (g) { geo = g; } }
      ).then(function (sheetOverlay) {
        sheetBands[idx] = geo ? buildSheetBands(sheetOverlay, geo, F) : null;
      });
    });

    return Promise.all(jobs).then(function () {
      return {
        platePlain: platePlain,
        plateDim: plateDim,
        collageBands: collageBands,
        sheetBands: sheetBands
      };
    });
  }

  /* ── Timeline ─────────────────────────────────────────────────
     scenes: [{ canvas, hold }]
     Produces segments plus, for each scene, the window over which it
     is on screen — that window is what the Ken Burns push runs on,
     so the zoom carries continuously through a transition instead of
     resetting at the cut. */

  function buildTimeline(scenes) {
    var segs = [];
    var t = 0;

    scenes.forEach(function (s, i) {
      s.vis0 = (i === 0) ? 0 : t - VIDEO.trans;
      s.hold0 = t;
      segs.push({ kind: 'hold', a: i, start: t, dur: s.hold });
      t += s.hold;

      if (i < scenes.length - 1) {
        segs.push({ kind: 'trans', a: i, b: i + 1, start: t, dur: VIDEO.trans, tx: transitionAt(i) });
        t += VIDEO.trans;
        s.vis1 = t;
      } else {
        s.vis1 = t;
      }
    });

    // The entry clock. It starts partway INTO the incoming slide, so
    // the sheet assembles as it arrives rather than sliding in empty
    // and then filling itself — two events where there should be one.
    // The first scene has no incoming slide, so it waits out the
    // fade-in instead of performing underneath it.
    scenes.forEach(function (s, i) {
      s.motion0 = (i === 0)
        ? MOTION.introDelay
        : s.hold0 - VIDEO.trans * MOTION.lead;
    });

    return { segs: segs, duration: t };
  }

  /* Ends at 1.0 — the whole sheet, nothing cropped. Starts slightly in
     and settles out to it. The floor is 1.0 and not negotiable: the
     sheet already fills the frame at 1.0, so any value below that
     exposes the stage behind it as a black border inside the slot. */
  function sceneZoom(s, time) {
    if (!VIDEO.kenBurns) return 1;
    var span = Math.max(0.001, s.vis1 - s.vis0);
    var p = clamp01((time - s.vis0) / span);
    var eased = 1 - Math.pow(1 - p, 3);        // settles rather than creeps
    return VIDEO.kenBurnsOut
      ? 1 + VIDEO.kenBurns * (1 - eased)       // 1.04 → 1.00, lands on full frame
      : 1 + VIDEO.kenBurns * eased;            // 1.00 → 1.04, the old direction
  }

  function renderAt(ctx, W, H, scenes, tl, time) {
    ctx.clearRect(0, 0, W, H);

    var seg = tl.segs[tl.segs.length - 1];
    for (var i = 0; i < tl.segs.length; i++) {
      var s = tl.segs[i];
      if (time < s.start + s.dur) { seg = s; break; }
    }

    var A = scenes[seg.a];

    if (seg.kind === 'hold') {
      paintSlot(ctx, W, H, sceneSurface(A, time, 0, W, H), 0, sceneZoom(A, time));
    } else {
      var B = scenes[seg.b];
      var t = clamp01((time - seg.start) / seg.dur);
      var zA = sceneZoom(A, time);
      var zB = sceneZoom(B, time);

      // Slot 0 is the outgoing scene, slot 1 the incoming — at most
      // two are ever on screen, so two scratch buffers cover it.
      var sA = sceneSurface(A, time, 0, W, H);
      var sB = sceneSurface(B, time, 1, W, H);

      if (seg.tx === 'dissolve')     transDissolve(ctx, W, H, sA, sB, zA, zB, t);
      else if (seg.tx === 'sweep')   transSweep(ctx, W, H, sA, sB, zA, zB, t);
      else if (seg.tx === 'push')    transPush(ctx, W, H, sA, sB, zA, zB, t);
      else                           transSlide(ctx, W, H, sA, sB, zA, zB, t);
    }

    // top and tail
    var fade = 0;
    if (time < VIDEO.fadeIn) fade = 1 - easeInOutCubic(time / VIDEO.fadeIn);
    var outStart = tl.duration - VIDEO.fadeOut;
    if (time > outStart) fade = Math.max(fade, easeInOutCubic((time - outStart) / VIDEO.fadeOut));

    if (fade > 0.001) {
      ctx.fillStyle = 'rgba(0, 0, 0, ' + Math.min(1, fade).toFixed(3) + ')';
      ctx.fillRect(0, 0, W, H);
    }
  }

  /* ── Codec pick ───────────────────────────────────────────────
     1080x1920 is 8160 macroblocks, over Level 3.1's ceiling, so the
     usual avc1.42E01E string is rejected on the vertical format.
     Walk down from High 4.0 and take the first the machine accepts. */

  var H264_CANDIDATES = [
    'avc1.640028',   // High 4.0
    'avc1.4D0028',   // Main 4.0
    'avc1.42002A',   // Baseline 4.2
    'avc1.640033'    // High 5.1
  ];

  function pickCodec(W, H) {
    var i = 0;
    function tryNext() {
      if (i >= H264_CANDIDATES.length) return Promise.resolve(null);
      var codec = H264_CANDIDATES[i++];
      return VideoEncoder.isConfigSupported({
        codec: codec,
        width: W,
        height: H,
        bitrate: VIDEO.bitrate,
        framerate: VIDEO.fps
      }).then(function (r) {
        return (r && r.supported) ? codec : tryNext();
      }).catch(function () { return tryNext(); });
    }
    return tryNext();
  }

  /* ── Encode (WebCodecs) ───────────────────────────────────────
     Frame-by-frame, not real time. That is the whole reason for
     WebCodecs here: MediaRecorder samples the wall clock, so a
     stutter in the tab becomes a stutter in the file. */

  function encodeWebCodecs(scenes, F, onProgress) {
    return loadMuxer().then(function (Mux) {
      if (!Mux) return null;

      return pickCodec(F.W, F.H).then(function (codec) {
        if (!codec) return null;

        var tl = buildTimeline(scenes);
        var total = Math.max(1, Math.round(tl.duration * VIDEO.fps));

        var stage = document.createElement('canvas');
        stage.width = F.W;
        stage.height = F.H;
        var ctx = stage.getContext('2d', { alpha: false });
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        var muxer = new Mux.Muxer({
          target: new Mux.ArrayBufferTarget(),
          video: { codec: 'avc', width: F.W, height: F.H },
          fastStart: 'in-memory'                 // playable without a full download
        });

        var failed = null;
        var encoder = new VideoEncoder({
          output: function (chunk, meta) { muxer.addVideoChunk(chunk, meta); },
          error: function (e) { failed = e; console.error('[video] encoder', e); }
        });

        encoder.configure({
          codec: codec,
          width: F.W,
          height: F.H,
          bitrate: VIDEO.bitrate,
          framerate: VIDEO.fps,
          latencyMode: 'quality'
        });

        var usPerFrame = 1000000 / VIDEO.fps;
        var gop = VIDEO.fps * 2;
        var f = 0;

        function drain() {
          if (encoder.encodeQueueSize < 8) return Promise.resolve();
          return new Promise(function (r) {
            encoder.addEventListener('dequeue', function once() {
              if (encoder.encodeQueueSize < 8) {
                encoder.removeEventListener('dequeue', once);
                r();
              }
            });
          });
        }

        function step() {
          if (failed) return Promise.reject(failed);
          if (f >= total) return Promise.resolve();

          renderAt(ctx, F.W, F.H, scenes, tl, f / VIDEO.fps);

          var frame = new VideoFrame(stage, {
            timestamp: Math.round(f * usPerFrame),
            duration: Math.round(usPerFrame)
          });
          encoder.encode(frame, { keyFrame: (f % gop) === 0 });
          frame.close();

          f++;
          if (onProgress && f % 15 === 0) onProgress(f / total);

          return drain().then(function () {
            // yield so the tab stays responsive and the toasts paint
            return (f % 12 === 0)
              ? new Promise(function (r) { setTimeout(r, 0); }).then(step)
              : step();
          });
        }

        return step()
          .then(function () { return encoder.flush(); })
          .then(function () {
            muxer.finalize();
            encoder.close();
            return {
              blob: new Blob([muxer.target.buffer], { type: 'video/mp4' }),
              ext: 'mp4',
              seconds: tl.duration
            };
          })
          .catch(function (err) {
            // v15: close on the failure path too. v14 only closed on
            // success, so a mid-encode error leaked the encoder and the
            // next attempt in the same session could stall.
            try { if (encoder.state !== 'closed') encoder.close(); } catch (e) {}
            throw err;
          });
      });
    });
  }

  /* ── Fallback (MediaRecorder) ─────────────────────────────────
     Real-time capture. Chrome and Safari can hand back MP4 here;
     Firefox cannot, and you get WebM. The extension follows what
     was actually produced rather than pretending. */

  function encodeMediaRecorder(scenes, F, onProgress) {
    return new Promise(function (resolve) {
      var types = [
        'video/mp4;codecs=avc1.640028',
        'video/mp4',
        'video/webm;codecs=vp9',
        'video/webm'
      ];
      var mime = null;
      for (var i = 0; i < types.length; i++) {
        if (window.MediaRecorder && MediaRecorder.isTypeSupported(types[i])) { mime = types[i]; break; }
      }
      if (!mime) { resolve(null); return; }

      var tl = buildTimeline(scenes);
      var stage = document.createElement('canvas');
      stage.width = F.W;
      stage.height = F.H;
      var ctx = stage.getContext('2d', { alpha: false });

      var stream = stage.captureStream(VIDEO.fps);
      var rec = new MediaRecorder(stream, { mimeType: mime, videoBitsPerSecond: VIDEO.bitrate });
      var parts = [];

      rec.ondataavailable = function (e) { if (e.data && e.data.size) parts.push(e.data); };
      rec.onstop = function () {
        resolve({
          blob: new Blob(parts, { type: mime.split(';')[0] }),
          ext: mime.indexOf('mp4') >= 0 ? 'mp4' : 'webm',
          seconds: tl.duration
        });
      };

      var t0 = performance.now();
      rec.start();

      (function loop() {
        var time = (performance.now() - t0) / 1000;
        if (time >= tl.duration) { rec.stop(); return; }
        renderAt(ctx, F.W, F.H, scenes, tl, time);
        if (onProgress) onProgress(time / tl.duration);
        requestAnimationFrame(loop);
      })();
    });
  }

  /* ── Entry point ──────────────────────────────────────────────
     Same signature as createZipFile, plus the optional motion data. */

  function createVideoFile(collageCanvas, cardCanvases, cardNames, cardRanks, F, motion) {
    var timestamp = new Date().toISOString().slice(0, 10);
    var count = cardCanvases.length;

    // Scene order IS rail order: cardCanvases[] was filled by index.
    var scenes = [{ canvas: collageCanvas, hold: VIDEO.holdCollage }];
    if (motion) attachMotion(scenes[0], motion.platePlain, motion.collageBands);

    cardCanvases.forEach(function (c, i) {
      var s = {
        canvas: c,
        hold: VIDEO.holdCard + (i === cardCanvases.length - 1 && !VIDEO.endCard ? VIDEO.tail : 0)
      };
      if (motion) attachMotion(s, motion.plateDim, motion.sheetBands[i]);
      scenes.push(s);
    });

    // The closing collage resolves the video; re-running its entry
    // would read as the piece starting over.
    if (VIDEO.endCard) {
      var endScene = { canvas: collageCanvas, hold: VIDEO.holdEndCard };
      if (motion && MOTION.animateEndCard) {
        attachMotion(endScene, motion.platePlain, motion.collageBands);
      }
      scenes.push(endScene);
    }

    var hasWebCodecs = typeof window.VideoEncoder === 'function' && typeof window.VideoFrame === 'function';
    var last = -1;

    function progress(p) {
      var pct = Math.round(p * 100);
      if (pct >= last + 20) {
        last = pct;
        showToast('🎬 Renderizando video… ' + pct + '%', 'success');
      }
    }

    showToast('🎬 Preparando video (' + F.label + ' ' + F.W + '×' + F.H + ')…', 'success');

    var job = hasWebCodecs
      ? encodeWebCodecs(scenes, F, progress).then(function (r) {
          return r || encodeMediaRecorder(scenes, F, progress);
        })
      : encodeMediaRecorder(scenes, F, progress);

    return job.then(function (result) {
      if (!result) {
        showToast('❌ Este navegador no puede generar video. Usa la salida ZIP.', 'error');
        return;
      }

      var name = 'NENSONS_TOP' + count + '_' + F.tag + '_' + timestamp + '.' + result.ext;
      var url = URL.createObjectURL(result.blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(function () { URL.revokeObjectURL(url); }, 4000);

      var mb = (result.blob.size / 1048576).toFixed(1);
      showToast('✅ ' + name + ' · ' + result.seconds.toFixed(1) + 's · ' + mb + ' MB', 'success');

      if (result.ext === 'webm') {
        showToast('⚠️ Tu navegador entregó .webm en vez de .mp4', 'error');
      }
    }).catch(function (err) {
      console.error('[video]', err);
      showToast('❌ Error generando el video', 'error');
    });
  }

  function createZipFile(collageCanvas, cardCanvases, cardNames, cardRanks, F) {
    var timestamp = new Date().toISOString().slice(0, 10);
    var count = cardCanvases.length;
    var tag = F.tag;

    showToast('📦 Empaquetando archivos…', 'success');

    loadJSZip().then(function(ZipLib) {
      if (!ZipLib) {
        showToast('❌ Error: No se pudo cargar la librería ZIP', 'error');
        return;
      }

      var zip = new ZipLib();
      var filesAdded = 0;
      var totalFiles = 1 + cardCanvases.length;
      var allBlobsReady = false;

      var downloadZipOnce = function() {
        if (filesAdded === totalFiles && allBlobsReady) {
          zip.generateAsync({ type: 'blob' }).then(function(content) {
            var url = URL.createObjectURL(content);
            var link = document.createElement('a');
            link.href = url;
            link.download = 'NENSONS_TOP' + count + '_' + tag + '_' + timestamp + '.zip';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            showToast('✅ ZIP descargado: NENSONS_TOP' + count + '_' + tag + '_' + timestamp + '.zip', 'success');
          });
        }
      };

      // Add collage
      collageCanvas.toBlob(function(blob) {
        zip.file('00_TOP' + count + '_' + tag + '_Collage_' + timestamp + '.jpg', blob);
        filesAdded++;
        showToast('📥 Collage agregado al ZIP (' + filesAdded + '/' + totalFiles + ')', 'success');
        downloadZipOnce();
      }, 'image/jpeg', 0.98);

      // Add individual cards
      cardCanvases.forEach(function(canvas, idx) {
        canvas.toBlob(function(blob) {
          var cleanName = cardNames[idx].replace(/[^a-z0-9]/gi, '_').substring(0, 25);
          var filename = ('0' + (cardRanks[idx])).slice(-2) + '_' + cleanName + '_' + tag + '_' + timestamp + '.jpg';
          zip.file(filename, blob);
          filesAdded++;
          showToast('📥 Card #' + cardRanks[idx] + ' agregada al ZIP (' + filesAdded + '/' + totalFiles + ')', 'success');
          downloadZipOnce();
        }, 'image/jpeg', 0.98);
      });

      allBlobsReady = true;
    });
  }

  /* ═══════════════════════════════════════════════════════════════
     MAIN COLLAGE DOWNLOAD
     ═══════════════════════════════════════════════════════════════ */

  function downloadCollageWithBackground(section, cards, changeData, button, titleData) {
    var F = fmt();
    console.log('DEBUG: collage for ' + cards.length + ' card(s) · ' +
                F.label + ' ' + F.W + 'x' + F.H);

    if (button) {
      button.disabled = true;
      button.innerHTML = '⟳ Generando…';
    }

    selectedBackground = getRandomBackground(F);

    loadImage(selectedBackground, 12000).then(function(bgImg) {
      if (!bgImg) {
        showToast('❌ Error al cargar fondo (' + F.label + ')', 'error');
        if (button) {
          button.disabled = false;
          button.innerHTML = '⬇ Descargar';
        }
        return;
      }

      var canvas = document.createElement('canvas');
      canvas.width = F.W;
      canvas.height = F.H;
      var ctx = canvas.getContext('2d');

      // Draw background
      drawCover(ctx, bgImg, canvas.width, canvas.height);

      // ★★★ BUILD DYNAMIC TITLES ★★★
      var builtTitles = buildTitles(titleData);
      var titleText = builtTitles.mainTitle;
      var showChange = false;

      if (section.includes('GANADOR') || section.includes('PERDED') || section.includes('MOVER')) {
        showChange = true;
      }

      // ★★★ INFO ROWS — always at most two ★★★
      var seg = buildSegments(builtTitles);
      var titleRows = [];

      if (seg.query.length || seg.set.length) titleRows.push(seg.query.concat(seg.set));

      var secondRow = seg.chips.concat(seg.price);
      if (secondRow.length) titleRows.push(secondRow);

      if (!titleRows.length && builtTitles.fallbackLine) {
        titleRows.push([{ type: 'text', text: builtTitles.fallbackLine }]);
      }

      drawTitle(ctx, canvas, titleText, titleRows, builtTitles.setName, F);

      var imagePromises = cards.map(function(card) {
        return loadImage(card.image);
      });

      Promise.all(imagePromises).then(function(images) {
        var missing = images.filter(function (i) { return !i; }).length;
        if (missing) showToast('⚠️ ' + missing + ' imagen(es) no cargaron', 'error');

        // Draw cards grid
        drawCardsGrid(ctx, canvas, cards, images, changeData, showChange, F);

        var cardCanvases = [];
        var cardNames = [];
        var cardRanks = [];

        // The BADGE printed on each sheet uses card.rank (the real number the
        // page shows). The FILENAME prefix stays on idx + 1, so the ZIP lists
        // 01, 02, 03… in rail order.
        var sheetJobs = cards.map(function(card, idx) {
          return createIndividualCard(bgImg, card, images[idx], card.rank, titleData, showChange, F)
            .then(function(cardCanvas) {
              cardCanvases[idx] = cardCanvas;
              cardNames[idx] = card.name;
              cardRanks[idx] = idx + 1;   // file order, not the medal number
            });
        });

        Promise.all(sheetJobs).then(function () {
          if (outputMode !== 'mp4') {
            createZipFile(canvas, cardCanvases, cardNames, cardRanks, F);
            return;
          }

          if (!MOTION.enabled) {
            createVideoFile(canvas, cardCanvases, cardNames, cardRanks, F, null);
            return;
          }

          // v15: second render pass — the same sheets on transparent
          // canvases, sliced into bands. A failure here should cost the
          // animation, not the export.
          buildMotionData(bgImg, cards, images, changeData, showChange,
                          titleData, titleText, titleRows, builtTitles.setName, F)
            .then(function (motion) {
              createVideoFile(canvas, cardCanvases, cardNames, cardRanks, F, motion);
            })
            .catch(function (err) {
              console.warn('[video] motion pass failed, falling back to flat sheets', err);
              createVideoFile(canvas, cardCanvases, cardNames, cardRanks, F, null);
            });
        });

        if (button) {
          button.innerHTML = '✅ Listo';
          setTimeout(function () {
            button.disabled = false;
            button.innerHTML = '⬇ Descargar';
          }, 2000);
        }
      });

    }).catch(function(error) {
      console.error('Error:', error);
      showToast('❌ Error generando collage', 'error');
      if (button) {
        button.disabled = false;
        button.innerHTML = '⬇ Descargar';
      }
    });
  }

  /* ═══════════════════════════════════════════════════════════════
     EXPORT MENU
     ═══════════════════════════════════════════════════════════════ */

  function showExportMenu(section, cards, changeData, button, titleData) {
    var menu = document.createElement('div');
    menu.className = 'export-menu';

    var inner = document.createElement('div');
    inner.className = 'export-menu-inner';

    var title = document.createElement('div');
    title.className = 'export-menu-title';
    title.textContent = 'Descargar collage + cards';

    var desc = document.createElement('div');
    desc.style.cssText = 'font-size:12px;color:#FFF;margin:8px 0;text-align:center;';
    desc.textContent = '📦 1 ZIP con collage + ' + cards.length + ' card' +
      (cards.length === 1 ? '' : 's') + ' (#' +
      cards.map(function (c) { return c.rank; }).join(', #') + ')';

    // ── Formato ─────────────────────────────────────────────────
    // Instagram = 1080x1080, YouTube = 1080x1920. Each format has its
    // own background set; the choice sticks until the page reloads.
    var fmtWrap = document.createElement('div');
    fmtWrap.style.cssText =
      'display:flex;align-items:center;justify-content:center;gap:8px;margin:14px 0 4px;flex-wrap:wrap;';

    var fmtLbl = document.createElement('label');
    fmtLbl.textContent = 'Formato';
    fmtLbl.style.cssText =
      'font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#5F7488;';

    var fmtDims = document.createElement('span');
    fmtDims.style.cssText = 'font-size:11px;color:#5F7488;min-width:82px;text-align:left;';

    var fmtBtns = {};

    function paintFmt() {
      Object.keys(fmtBtns).forEach(function (k) {
        var on = (k === exportFormat);
        fmtBtns[k].style.background = on ? '#FFD700' : '#121A24';
        fmtBtns[k].style.color = on ? '#000' : '#E8EFF5';
        fmtBtns[k].style.borderColor = on ? '#FFD700' : 'rgba(122,152,180,.28)';
        fmtBtns[k].style.fontWeight = on ? 'bold' : 'normal';
      });
      fmtDims.textContent = FORMATS[exportFormat].W + ' × ' + FORMATS[exportFormat].H;
    }

    fmtWrap.appendChild(fmtLbl);

    ['instagram', 'youtube'].forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = FORMATS[k].btn;
      b.style.cssText =
        'border:1px solid rgba(122,152,180,.28);border-radius:999px;' +
        'padding:7px 14px;font-size:13px;cursor:pointer;background:#121A24;color:#E8EFF5;';
      b.onclick = function () { exportFormat = k; paintFmt(); };
      fmtBtns[k] = b;
      fmtWrap.appendChild(b);
    });

    fmtWrap.appendChild(fmtDims);
    paintFmt();

    // ── Salida ──────────────────────────────────────────────────
    // ZIP keeps v14's behaviour. Video renders the same sheets as an
    // animated sequence in rail order and downloads one .mp4.
    var outWrap = document.createElement('div');
    outWrap.style.cssText =
      'display:flex;align-items:center;justify-content:center;gap:8px;margin:10px 0 4px;flex-wrap:wrap;';

    var outLbl = document.createElement('label');
    outLbl.textContent = 'Salida';
    outLbl.style.cssText =
      'font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#5F7488;';

    var outNote = document.createElement('span');
    outNote.style.cssText = 'font-size:11px;color:#5F7488;min-width:96px;text-align:left;';

    var outBtns = {};
    var OUT_LABELS = { zip: '🖼 ZIP', mp4: '🎬 Video MP4' };

    function paintOut() {
      Object.keys(outBtns).forEach(function (k) {
        var on = (k === outputMode);
        outBtns[k].style.background = on ? '#FFD700' : '#121A24';
        outBtns[k].style.color = on ? '#000' : '#E8EFF5';
        outBtns[k].style.borderColor = on ? '#FFD700' : 'rgba(122,152,180,.28)';
        outBtns[k].style.fontWeight = on ? 'bold' : 'normal';
      });

      if (outputMode === 'mp4') {
        var secs = VIDEO.holdCollage +
                   cards.length * VIDEO.holdCard +
                   (VIDEO.endCard ? VIDEO.holdEndCard : VIDEO.tail) +
                   (cards.length + (VIDEO.endCard ? 1 : 0)) * VIDEO.trans;
        outNote.textContent = '≈ ' + secs.toFixed(0) + 's · ' + VIDEO.fps + 'fps';
        startBtn.textContent = '🎬 Generar video';
      } else {
        outNote.textContent = (1 + cards.length) + ' imágenes';
        startBtn.textContent = '⬇ Generar ZIP';
      }
    }

    outWrap.appendChild(outLbl);

    ['zip', 'mp4'].forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = OUT_LABELS[k];
      b.style.cssText =
        'border:1px solid rgba(122,152,180,.28);border-radius:999px;' +
        'padding:7px 14px;font-size:13px;cursor:pointer;background:#121A24;color:#E8EFF5;';
      b.onclick = function () { outputMode = k; paintOut(); };
      outBtns[k] = b;
      outWrap.appendChild(b);
    });

    outWrap.appendChild(outNote);

    // ── MXN → USD rate ──────────────────────────────────────────
    // Seeded from the snapshot, editable per export. Blank means the
    // sheets print MXN alone.
    exportRate = defaultRate();

    var rateWrap = document.createElement('div');
    rateWrap.style.cssText =
      'display:flex;align-items:center;justify-content:center;gap:8px;margin:14px 0 4px;';

    // ── Título ──────────────────────────────────────────────────
    // Pre-filled with what the search would print; edit it to something
    // shorter when the term list runs long.
    titleOverride = '';
    var autoLine = buildTitles(titleData).queryLine;

    var titWrap = document.createElement('div');
    titWrap.style.cssText =
      'display:flex;align-items:center;justify-content:center;gap:8px;margin:10px 0 4px;';

    var titLbl = document.createElement('label');
    titLbl.textContent = 'Título';
    titLbl.style.cssText =
      'font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#5F7488;';

    var titIn = document.createElement('input');
    titIn.type = 'text';
    titIn.placeholder = autoLine || 'sin subtítulo';
    titIn.value = autoLine || '';
    titIn.style.cssText =
      'flex:1;max-width:280px;background:#121A24;' +
      'border:1px solid rgba(122,152,180,.28);border-radius:999px;' +
      'padding:7px 14px;font-size:13px;color:#E8EFF5;';

    titIn.addEventListener('input', function () {
      titleOverride = titIn.value.trim();
    });
    titleOverride = titIn.value.trim();

    titWrap.appendChild(titLbl);
    titWrap.appendChild(titIn);

    var rateLbl = document.createElement('label');
    rateLbl.textContent = 'Tipo de cambio';
    rateLbl.style.cssText =
      'font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#5F7488;';

    var rateIn = document.createElement('input');
    rateIn.type = 'number';
    rateIn.step = '0.01';
    rateIn.min = '0';
    rateIn.placeholder = 'MXN/USD';
    rateIn.value = exportRate != null ? exportRate : '';
    rateIn.style.cssText =
      'width:96px;background:#121A24;border:1px solid rgba(122,152,180,.28);' +
      'border-radius:999px;padding:7px 12px;font-size:13px;color:#E8EFF5;' +
      'text-align:center;';

    var ratePrev = document.createElement('span');
    ratePrev.style.cssText = 'font-size:11px;color:#5F7488;min-width:90px;text-align:left;';

    function syncRate() {
      var n = parseFloat(rateIn.value);
      exportRate = (isNaN(n) || n <= 0) ? null : n;
      ratePrev.textContent = exportRate
        ? '$1,000 → ' + money(1000 / exportRate, 'USD')
        : 'solo MXN';
    }

    rateIn.addEventListener('input', syncRate);
    syncRate();

    rateWrap.appendChild(rateLbl);
    rateWrap.appendChild(rateIn);
    rateWrap.appendChild(ratePrev);

    var startBtn = document.createElement('button');
    startBtn.className = 'export-option';
    startBtn.textContent = '⬇ Generar ZIP';
    startBtn.type = 'button';
    startBtn.style.cssText = 'background-color: #FFD700; color: #000; font-weight: bold; padding: 12px 24px; font-size: 14px; border: none; border-radius: 6px; cursor: pointer; transition: all 0.3s ease;';
    startBtn.onmouseover = function() { startBtn.style.backgroundColor = '#FFA500'; };
    startBtn.onmouseout = function() { startBtn.style.backgroundColor = '#FFD700'; };
    startBtn.onclick = function () {
      menu.remove();
      downloadCollageWithBackground(section, cards, changeData, button, titleData);
    };

    // paintOut() touches startBtn, so it can only run once that exists.
    paintOut();

    var closeBtn = document.createElement('button');
    closeBtn.className = 'export-close';
    closeBtn.setAttribute('aria-label', 'Cerrar');
    closeBtn.textContent = '✕';
    closeBtn.type = 'button';
    closeBtn.style.cssText = 'background-color: transparent; color: #FFF; font-size: 24px; border: none; cursor: pointer; padding: 0; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center;';
    closeBtn.onclick = function () { menu.remove(); };

    inner.appendChild(title);
    inner.appendChild(desc);
    inner.appendChild(fmtWrap);
    inner.appendChild(outWrap);
    inner.appendChild(rateWrap);
    inner.appendChild(titWrap);
    inner.appendChild(startBtn);
    inner.appendChild(closeBtn);
    menu.appendChild(inner);

    menu.onclick = function (e) {
      if (e.target === menu) menu.remove();
    };

    document.body.appendChild(menu);
  }

  /* Real percentages read off the page. Cards without one draw no change row. */
  function getPriceChanges(cards) {
    return {
      changes: cards.map(function (c) {
        return (typeof c.change === 'number' && !isNaN(c.change)) ? c.change : null;
      }),
      period: 'SEMANAL'
    };
  }

  /* ═══════════════════════════════════════════════════════════════
     GET DYNAMIC TITLE FROM PAGE CONTEXT
     ═══════════════════════════════════════════════════════════════ */

  function getDynamicTitleData(section, count, filterKey) {
    section = section || 'TOP 10';
    filterKey = filterKey || section;

    // Scoped to the set popups only. A looser selector grabs the first
    // checked checkbox on the page, so ticking a colour or rarity first
    // puts "rojo" in the title instead of the set.
    var SECTION_KEYS = { 'TOP 10': 'top10', 'TOP MOVERS': 'movers', 'MARKET BOARD': 'board' };

    function checkedSetsIn(root) {
      var out = [];
      if (!root) return out;
      Array.prototype.forEach.call(
        root.querySelectorAll('input[type="checkbox"]:checked'),
        function (input) { if (input.value) out.push(input.value); }
      );
      return out;
    }

    // A section with its own filter bar wins over the global toolbar.
    var secKey = SECTION_KEYS[filterKey];
    var secBar = secKey ? document.getElementById('filters-' + secKey) : null;

    function facetValues(facet, globalPopId) {
      var own = secBar ? secBar.querySelector('.ms-pop[data-facet="' + facet + '"]') : null;
      var vals = checkedSetsIn(own);
      if (!vals.length) vals = checkedSetsIn(document.getElementById(globalPopId));
      return vals;
    }

    var setCodes  = facetValues('set', 'setPop');
    var colors    = facetValues('color', 'colorPop');
    var rarities  = facetValues('rarity', 'rarityPop');

    // SET DISPLAY: "OP01 - ROMANCE DAWN", or just "OP01" if the label
    // carries no long name.
    var setName = '';
    if (setCodes.length === 1) {
      var selectedSetCode = setCodes[0];
      setName = selectedSetCode;
      var setLabels = document.querySelectorAll('label.ms-opt');
      for (var i = 0; i < setLabels.length; i++) {
        var label = setLabels[i];
        if (label.textContent.trim() === selectedSetCode) {
          var fullNameElement = label.querySelector('[data-set-name]') ||
                                label.parentElement.querySelector('[data-set-name]');
          if (fullNameElement) {
            var fullName = fullNameElement.textContent.trim();
            if (fullName && fullName.toUpperCase() !== selectedSetCode.toUpperCase()) {
              setName = selectedSetCode + ' - ' + fullName;
            }
          }
          break;
        }
      }
    }

    // PRICE RANGE — the section's own inputs win over the toolbar
    function priceInput(which, globalId) {
      var own = secBar ? secBar.querySelector('input[type="number"][data-f="' + which + '"]') : null;
      if (own && own.value !== '') return own;
      return document.getElementById(globalId);
    }

    var minPriceInput = priceInput('min', 'minP');
    var minPrice = minPriceInput && minPriceInput.value ? parseFloat(minPriceInput.value) : null;

    var maxPriceInput = priceInput('max', 'maxP');
    var maxPrice = maxPriceInput && maxPriceInput.value ? parseFloat(maxPriceInput.value) : null;

    // SEARCH TERM — the section's own box wins over the toolbar
    function searchTerm() {
      var own = secBar ? secBar.querySelector('input[data-f="q"]') : null;
      if (own && own.value.trim()) return own.value.trim();
      var g = document.getElementById('search');
      return g && g.value.trim() ? g.value.trim() : '';
    }

    var query = searchTerm();

    // DETERMINE DISPLAY SECTION — count is real, not hard-coded
    var displaySection = 'TOP ' + count;
    if (section.includes('GANADOR')) {
      displaySection = 'TOP GANADORES';
    } else if (section.includes('PERDED')) {
      displaySection = 'TOP PERDEDORES';
    } else if (section.includes('MOVER')) {
      displaySection = 'TOP MOVERS';
    }

    return {
      section: section,
      displaySection: displaySection,
      setName: setName,
      setCodes: setCodes,
      colors: colors,
      rarities: rarities,
      minPrice: minPrice,
      maxPrice: maxPrice,
      query: query,
      count: count
    };
  }

  /* ═══════════════════════════════════════════════════════════════
     BUILD TITLE STRINGS FOR COLLAGE AND CARDS
     ═══════════════════════════════════════════════════════════════ */

  var SET_TITLE_MODE = 'never';  // 'never' | 'auto'
  var SET_JOIN_MAX = 2;          // ('auto' only) codes allowed in the gold row
  var SET_JOIN_CHARS = 11;       // ('auto' only) max width of that label
  var SET_LIST_MAX = 4;          // codes shown below before "+N"
  var CHIP_MAX_PER_FACET = 4;    // colours / rarities shown before a "+N" chip

  function buildTitles(titleData) {
    var mainTitle = titleData.displaySection;
    var codes = titleData.setCodes || [];
    var n = codes.length;

    // ── The compact label that rides in the gold row ──────────────
    var setLabel = '';
    if (SET_TITLE_MODE !== 'never') {
      if (n === 1) {
        setLabel = titleData.setName || codes[0];
      } else if (n > 1) {
        var joined = codes.join('+');
        setLabel = (n <= SET_JOIN_MAX && joined.length <= SET_JOIN_CHARS) ? joined : (n + ' SETS');
      }
    }

    // ── The full list for the smaller line underneath ─────────────
    var setLine = '';
    if (n === 1 && !setLabel) {
      setLine = titleData.setName || codes[0];
    } else if (n > 1) {
      setLine = n > SET_LIST_MAX
        ? codes.slice(0, SET_LIST_MAX).join(' · ') + ' +' + (n - SET_LIST_MAX)
        : codes.join(' · ');
    }

    // ── Price range ───────────────────────────────────────────────
    var priceRange = '';
    if (titleData.minPrice && titleData.maxPrice) {
      priceRange = '$' + titleData.minPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' - $' + titleData.maxPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else if (titleData.minPrice) {
      priceRange = 'MIN $' + titleData.minPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else if (titleData.maxPrice) {
      priceRange = 'MAX $' + titleData.maxPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // ── Search term ───────────────────────────────────────────────
    var queryLine = '';
    if (titleOverride) {
      queryLine = titleOverride;
    } else if (titleData.query) {
      var parts = titleData.query.split(/[,;|]+|\s+-\s+|\s{2,}/)
        .map(function (s) { return s.trim(); })
        .filter(Boolean)
        .map(function (s) {
          return s.split(/\s+/).map(function (w) {
            return w.charAt(0).toUpperCase() + w.slice(1);
          }).join(' ');
        });
      queryLine = 'Cartas ' + parts.join(', ');
    }

    // ── Colour + rarity chips ─────────────────────────────────────
    var colors = titleData.colors || [];
    var rarities = titleData.rarities || [];
    var chips = [];

    colors.slice(0, CHIP_MAX_PER_FACET).forEach(function (v) { chips.push(colorChip(v)); });
    if (colors.length > CHIP_MAX_PER_FACET) {
      chips.push({ label: '+' + (colors.length - CHIP_MAX_PER_FACET), c1: '#7A98B4', c2: '#33475A' });
    }

    rarities.slice(0, CHIP_MAX_PER_FACET).forEach(function (v) { chips.push(rarityChip(v)); });
    if (rarities.length > CHIP_MAX_PER_FACET) {
      chips.push({ label: '+' + (rarities.length - CHIP_MAX_PER_FACET), c1: '#7A98B4', c2: '#33475A' });
    }

    // ── BELOW TEXT: sets, then price, then a fallback ─────────────
    var belowParts = [];
    if (queryLine) belowParts.push(queryLine);
    if (setLine) belowParts.push(setLine);
    if (priceRange) belowParts.push(priceRange);

    var belowText = belowParts.join(' • ');

    var fallbackLine = '';
    if (!belowText && !setLabel && !chips.length && !queryLine) {
      if (titleData.section.includes('GANADOR')) {
        fallbackLine = 'GANADORES';
      } else if (titleData.section.includes('PERDED')) {
        fallbackLine = 'PERDEDORES';
      } else {
        fallbackLine = 'CARTAS MÁS CARAS';
      }
      belowText = fallbackLine;
    }

    // subtitle kept for anything else that reads it
    var subtitle = [setLabel || setLine, priceRange].filter(Boolean).join(' • ');

    return {
      mainTitle: mainTitle,
      subtitle: subtitle,
      belowText: belowText,
      setLine: setLine,
      queryLine: queryLine,
      priceLine: priceRange,
      chips: chips,
      fallbackLine: fallbackLine,
      setName: setLabel,
      setCodes: codes,
      minPrice: titleData.minPrice,
      maxPrice: titleData.maxPrice,
      count: titleData.count
    };
  }

  /* ═══════════════════════════════════════════════════════════════
     VALIDATE GANADORES/PERDEDORES SELECTION
     ═══════════════════════════════════════════════════════════════ */

  function activeBoardTab() {
    var tab = document.querySelector('#boardTabs .tab.active');
    return tab ? tab.getAttribute('data-tab') : '';
  }

  /* MARKET BOARD → WHICH TAB IS ACTIVE? */
  function resolveSection(sectionName) {
    if (sectionName !== 'MARKET BOARD') {
      return { ok: true, title: sectionName, filterKey: sectionName };
    }

    var tab = activeBoardTab();

    if (tab === 'gainers') return { ok: true, title: 'TOP GANADORES', filterKey: 'MARKET BOARD' };
    if (tab === 'losers')  return { ok: true, title: 'TOP PERDEDORES', filterKey: 'MARKET BOARD' };
    if (tab === 'sets')    return { ok: false, message: '❌ La pestaña Sets ⇄ todavía no se puede descargar' };

    return { ok: false, message: '❌ Selecciona ▲ Ganadores o ▼ Perdedores para descargar' };
  }

  function validateSelection(resolved) {
    if (resolved.ok) return true;
    showToast(resolved.message, 'error');
    return false;
  }

  /* PUBLIC API */
  window.exportModule = {
    init: function (headerSelectors) {
      headerSelectors = headerSelectors || {};

      var defaults = {
        top10: '.sec-h:has(h3)',
        movers: '.sec-h:nth-of-type(3)',
        board: '.board-h',
      };

      var selectors = {};
      for (var key in defaults) {
        selectors[key] = headerSelectors[key] || defaults[key];
      }

      var addExportButton = function(sectionHeader, sectionName) {
        if (!sectionHeader || sectionHeader.querySelector('[data-export-btn]')) {
          return;
        }

        var button = document.createElement('button');
        button.className = 'export-btn';
        button.setAttribute('data-export-btn', sectionName);
        button.innerHTML = '⬇ Descargar';
        button.type = 'button';

        button.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();

          var resolved = resolveSection(sectionName);
          if (!validateSelection(resolved)) {
            return;
          }

          var scopeFn = SECTION_SCOPES[sectionName];
          var scope = scopeFn ? scopeFn() : null;

          var cards = getCardsFromBoard(scope);
          if (!cards || cards.length === 0) {
            cards = getCardsFromSnapshot(MAX_CARDS, scope);
          }

          if (!cards || cards.length === 0) {
            showToast('❌ No hay tarjetas visibles para descargar', 'error');
            return;
          }

          applyRanks(cards);

          console.log('✅ Export ' + resolved.title + ' · ' + cards.length + ' card(s)',
            cards.map(function (c) { return '#' + c.rank + ' ' + c.name + ' ' + c.change + '%'; }));

          var titleData = getDynamicTitleData(resolved.title, cards.length, resolved.filterKey);
          var changeData = getPriceChanges(cards);

          showExportMenu(resolved.title, cards, changeData, button, titleData);
        };

        sectionHeader.appendChild(button);
      };

      var top10Header = document.querySelector(selectors.top10);
      if (top10Header) {
        addExportButton(top10Header, 'TOP 10');
      }

      var moversHeader = document.querySelector(selectors.movers);
      if (moversHeader) {
        addExportButton(moversHeader, 'TOP MOVERS');
      }

      var boardHeader = document.querySelector(selectors.board);
      if (boardHeader) {
        addExportButton(boardHeader, 'MARKET BOARD');
      }
    },

    // console helper: window.exportModule.setFormat('youtube')
    setFormat: function (key) {
      if (FORMATS[key]) {
        exportFormat = key;
        console.log('Formato: ' + FORMATS[key].label + ' ' + FORMATS[key].W + 'x' + FORMATS[key].H);
      } else {
        console.warn('Formato desconocido. Usa "instagram" o "youtube".');
      }
      return exportFormat;
    },

    setOutput: function (key) {
      if (key === 'zip' || key === 'mp4') outputMode = key;
      return outputMode;
    },

    video: VIDEO,

    // Tune the feel from the console without a reload, e.g.
    //   exportModule.motion.sheet.title.rise = 24
    //   exportModule.motion.enabled = false   → v14's flat slides
    motion: MOTION,

    formats: FORMATS,

    // console helper: window.exportModule.preview('TOP 10')
    preview: function (sectionName) {
      var scopeFn = SECTION_SCOPES[sectionName || 'TOP 10'];
      var cards = applyRanks(getCardsFromBoard(scopeFn ? scopeFn() : null));
      console.table(cards.map(function (c) {
        return { rank: c.rank, name: c.name, price: c.price };
      }));
      return cards;
    }
  };

  // Auto-init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () {
        if (window.exportModule) {
          window.exportModule.init();
        }
      }, 1500);
    });
  } else {
    setTimeout(function () {
      if (window.exportModule) {
        window.exportModule.init();
      }
    }, 1500);
  }

  console.log('✅ NENSONS Export Module v15 (ELEMENT MOTION) loaded');

})();